/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran this thru claudes code refactoring tool


// suggest improvements for this component
// give me the entire code to copy

// redesign this component to look more elegant and polished and accents
// and add a little more pizzaz to the menu items and add hover effects 
// use tailwind css in the className directive 
// keep items summary where it is now, and it should move down as the user scrolls down
// it should always be visible
// give me the entire code to copy any insrtuctions to implement
// justthe feilds - no cards
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight,
// give me the entire code to copy


// create a button to show floorplanner in a modal popup
// <FloorPlanner showTopMenu={false} showSideMenu={false} />
// put the button next to save event details
// give me the entire code to copy
   

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { FaCircleCheck } from "react-icons/fa6";
import { FiSave } from 'react-icons/fi';
import { MdOutlineTableBar } from "react-icons/md";
import { TbListDetails } from "react-icons/tb";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { GiCheckMark } from "react-icons/gi";

import { place_order } from '../store/reducers/orderReducer';
import {
    update_event_details_not_deposit,
    get_event_details,
    messageClear
} from '../store/reducers/eventDetailsReducer';
import { get_sellerPackages_webSiteOrigin } from '../store/reducers/sellerPackageReducer';

import FloorPlanner from '../components/customerDashboard/FloorPlannerGridSize';
import { currencyFormat } from '../components/CurrencyFormat';
import { toTitleCase } from '../components/toTitleCase';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ShopBanner from '../components/ShopBanner';
import GetSellerConfig from '../components/GetSellerConfig';
import MultiSelectDropdown from '../components/MultiSelectDropdown';
import DiagnosticInfo from '../components/DiagnosticInfo';

import { formatPhoneNumber } from 'react-phone-number-input';
import Moment from 'moment';
import toast from 'react-hot-toast';

import config from '../config';

const safeJsonParse = (value, fallback = []) => {
    if (!value) return fallback;
    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const SummaryItem = ({ label, value, colorDark, colorMedium, colorLight }) => (
    <div
        className='flex flex-col gap-0.5 mb-2 w-full px-3 py-2 rounded-md'
        style={{ 
            borderLeft: `3px solid ${colorDark}`, 
            backgroundColor: colorLight 
        }}>
        <span className='text-[11px] font-semibold uppercase tracking-widest' style={{ colorMedium }}>{label}</span>
        <span className='text-[14px] font-medium'>{value}</span>
    </div>
);

const SelectedItemsPanel = ({ title, items, colorDark, colorMedium, colorLight, emptyLabel }) => (
    <div
        className="mt-1 p-2 rounded-md h-[80px] overflow-y-auto"
        style={{ 
            backgroundColor: colorLight, 
            border: `1px solid ${colorDark}` 
        }}>
        <div className="text-[11px] font-semibold uppercase tracking-widest mb-1" style={{ colorMedium }}>
            {title}
        </div>
        {items.length > 0 ? (
            <ul className="space-y-1">
                {items.map((item) => (
                    <li key={item.id} className="flex items-center justify-between w-full px-1 py-0 text-left">
                        <span className="font-normal text-[13px]" style={{ colorDark }}>{item.name}</span>
                        <GiCheckMark className="w-4 h-4 text-green-500 inline-block" />
                    </li>
                ))}
            </ul>
        ) : (
            <p className="italic text-[12px]" style={{ colorMedium }}>{emptyLabel}</p>
        )}
    </div>
);

// Section divider with heading
const SectionHeading = ({ label, color }) => (
    <div className='flex items-center gap-3 mt-5 mb-3'>
        <span
            className='text-[11px] font-bold uppercase tracking-widest whitespace-nowrap'
            style={{ color: color }}>
            {label}
        </span>
        <div className='flex-1 h-px' style={{ backgroundColor: color }} />
    </div>
);

// Styled input — injects glow on focus via inline style trick + Tailwind
const fieldBase =
    'w-full px-3 py-2 rounded-md border bg-white text-sm transition-all duration-200 outline-none placeholder-gray-300';

const StyledInput = ({ colorDark, colorMedium, colorLight, ...props }) => (
    <input
        {...props}
        className={fieldBase}
        style={{
            borderColor: colorMedium , 
            color: colorDark, 
            backgroundColor: 'white'
        }}
        onFocus={e => {
            e.target.style.borderColor = colorDark;
            e.target.style.backgroundColor = colorLight;
            //e.target.style.boxShadow = `0 0 0 3px ${color}20`;
        }}
        onBlur={e => {
            e.target.style.borderColor = colorMedium;
            e.target.style.backgroundColor = 'white';
            //e.target.style.boxShadow = 'none';
        }}
    />    
);

const StyledSelect = ({ colorDark, colorMedium, colorLight, children, ...props }) => (
    <select
        {...props}
        className={fieldBase + ' cursor-pointer'}
        style={{
            borderColor: colorMedium, 
            color: colorDark, 
            backgroundColor: 'white',
            height: '38px',
        }}
        onFocus={e => {
            e.target.style.borderColor = colorDark;
            e.target.style.backgroundColor = colorLight;
            //e.target.style.boxShadow = `0 0 0 3px ${color}20`;
        }}
        onBlur={e => {
            e.target.style.borderColor = colorMedium;
            e.target.style.backgroundColor = 'white';
            //e.target.style.boxShadow = 'none';
        }}>
        {children}
    </select>
);

const StyledTextarea = ({ colorDark, colorMedium, colorLight, ...props }) => (
    <textarea
        {...props}
        className={fieldBase + ' h-[110px] resize-none'}
        style={{
            borderColor: colorDark,
            color: colorDark,
            backgroundColor: 'white',
        }}
        onFocus={e => {
            e.target.style.borderColor = colorDark;
            e.target.style.backgroundColor = colorLight;
            //e.target.style.boxShadow = `0 0 0 3px ${color}20`;
        }}
        onBlur={e => {
            e.target.style.borderColor = colorDark;
            e.target.style.backgroundColor = 'white';
            //e.target.style.boxShadow = 'none';
        }}
    />
);

// Field wrapper with label
const Field = ({ label, required, isDeposit, isBalance, showRequired = true, children }) => (
    <div className='flex flex-col gap-1 w-full'>
        {
            //console.log('Field component render: label:', label, 'required:', required, 'isDeposit:', isDeposit, 'isBalance:', isBalance, 'showRequired:', showRequired)
        }
       <div className='text-[12px] h-[26px] flex items-center justify-items-center
            font-semibold uppercase tracking-wider border-none border-red-700'>
            {label}
            {required && (showRequired === 'always' || (showRequired && !isDeposit && !isBalance)) && (
                <span className='mt-0 ml-1 text-[18px] text-red-400 font-bold leading-none self-center'>*</span>
            )}
        </div>
        {children}
    </div>
);

const EventDetails = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;
    const sellerRequiredFieldColor = config.STR_FRONTEND_REQUIRED_FIELD_COLOR;
    const sellerEnvironment = config.STR_ENVIRONMENT;
    
    const { userInfo } = useSelector(state => state.auth);
    const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
    const { sellerPackages } = useSelector(state => state.sellerPackage);
    const { allSiteGalleryImages } = useSelector(state => state.home);

    const allSiteGalleryImagesNew = (allSiteGalleryImages ?? []).map(({ _id, caption, image }) => ({
        id: _id, name: caption, image
    }));

    const {
        sellerColorDark, sellerColorMedium, sellerColorLight,
        sellerPrimaryColor1, sellerSecondaryColor1,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, 
        sellerComponentBackgroundColor,
        sellerClothColors, sellerMinGuestCount, sellerServiceTypes, sellerProductTerm, sellerProductPluralTerm,
        sellerPlaceSettings, sellerOtherEventOptionsChoices, sellerBoolShowSitePayments, sellerEventTypeList,
    } = GetSellerConfig();

    const colorDark = sellerPrimaryColor1 + sellerColorSuffixDark;
    const colorMedium = sellerPrimaryColor1 + sellerColorSuffixMedium;
    const colorLight = sellerPrimaryColor1 + sellerColorSuffixLight;
    
    const sellerArrEventTypes = [
        ...new Set(
            (sellerEventTypeList ?? '')
                .split(';')
                .map((et) => et.trim())
                .filter((et) => et.length > 0)
        ),
    ];
    
    const [selectedItemsSelectedGalleryImages, setSelectedItemsSelectedGalleryImages] = useState([]);
    const [selectedItemsOtherEventOptions, setSelectedItemsOtherEventOptions] = useState([]);
    const [eventDetailsSaved, setEventDetailsSaved] = useState(true);
    const [res, setRes] = useState(false);
    const [showFloorPlanner, setShowFloorPlanner] = useState(false);

    const arrOtherEventOptionsChoicesNew = (sellerOtherEventOptionsChoices
        ? sellerOtherEventOptionsChoices.split(';')
        : []
    ).map((item, index) => ({ id: index, name: item }));

    const { state: { products, price, items } } = useLocation();
    const productName = products[0]?.products[0]?.productInfo.name;
    //console.log(`productName is a ${typeof productName}:`, productName);
    //const isDeposit = productName === 'Deposit';
    const isDeposit = productName?.includes('Deposit') || productName === 'Deposit';
    const depositAmountPaid = isDeposit ? price : 0;

    const isBalance = productName?.includes('Balance') || productName === 'Balance';
    const balanceAmountPaid = isBalance ? price : 0;


    // balanceGiven: boolIsBalance, // , //false,
    //                 balanceAmountPaid: price
    //{!isDeposit ? `${items} Items` : 'Deposit'}
                                                    
    //sellerProductTerm, sellerProductPluralTerm,
    //{!isDeposit ? 'Finalize My Menu' : 'Finalize My Deposit'} sellerProductTerm
                                                
    let priceLine = ''
    let finalizeLine = ''
    if (isDeposit) {
        priceLine = 'Deposit';
        finalizeLine = 'Finalize My Deposit';
    } else if (isBalance) {
        priceLine = 'Balance';
        finalizeLine = 'Finalize My Balance';
    } else {
        priceLine = `${items} Items`;
        finalizeLine = 'Finalize ' + sellerProductPluralTerm;
    }
    // console.log(`isBalance is a ${typeof isBalance}:`, isBalance);
    // const depositAmountPaid = isDeposit ? price : 0;
    // balancePaid: false, balanceAmountPaid: 0,
        
    //console.log(`isDeposit is a ${typeof isDeposit}:`, isDeposit, '\ndepositAmountPaid', depositAmountPaid);
    
    const orderType = 'Menu Order';

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (userInfo?.id) dispatch(get_event_details(userInfo.id));
    }, [dispatch, userInfo?.id]);

    useEffect(() => {
        dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL));
    }, [dispatch, sellerFrontendURL]);

    useEffect(() => {
        if (eventDetails) {
            setSelectedItemsSelectedGalleryImages(safeJsonParse(eventDetails.selectedGalleryImages));
            setSelectedItemsOtherEventOptions(safeJsonParse(eventDetails.otherEventOptions));
        }
    }, [eventDetails]);

    const [state, setState] = useState({
        depositGiven: isDeposit, depositAmountPaid: depositAmountPaid, 
        balancePaid: isBalance, balanceAmountPaid: balanceAmountPaid,
        eventName: '', selectedSellerPackage: 'None',
        venueName: '', venueAddress: '', eventType: '', eventDate: '',
        eventStartTime: '', eventServiceType: '', eventPlaceSettings: '',
        eventGuestTableclothColor: '', eventBuffetTableclothColor: '',
        eventNapkinColor: '', venueManagerContactInfo: '', venueDoorCode: '',
        eventGuestCount: '', eventNotes: '',
        floorPlanCanvasHeight: '', floorPlanCanvasWidth: '',
        floorPlanRoomHeight: '', floorPlanRoomWidth: '',
        floorPlan: '', floorPlanNotes: '',
        selectedGalleryImages: '[]', otherEventOptions: '[]',
        tableRequirements: '[]', utensilsAndEquipmentList: '[]', eventStaffList: '[]', 
        invoice: '[]', eventPartsTimeLine: '[]', coupon: '', couponDescription: '', couponExpirationDate: ''

    });

    //console.log('state', state);

    useEffect(() => {
        if (!eventDetails) return;
        setState({
            depositGiven: isDeposit, // eventDetails.depositGiven,
            depositAmountPaid: depositAmountPaid, // eventDetails.depositAmountPaid,
            balancePaid: isBalance,
            balanceAmountPaid: balanceAmountPaid,        
            eventName: eventDetails.eventName ?? '',
            selectedSellerPackage: eventDetails.selectedSellerPackage ?? 'None',
            venueName: eventDetails.venueName ?? '',
            venueAddress: eventDetails.venueAddress ?? '',
            eventType: eventDetails.eventType ?? '',
            eventDate: eventDetails.eventDate ?? '',
            eventStartTime: eventDetails.eventStartTime ?? '',
            eventServiceType: eventDetails.eventServiceType ?? '',
            eventPlaceSettings: eventDetails.eventPlaceSettings ?? '',
            eventGuestTableclothColor: eventDetails.eventGuestTableclothColor ?? '',
            eventBuffetTableclothColor: eventDetails.eventBuffetTableclothColor ?? '',
            eventNapkinColor: eventDetails.eventNapkinColor ?? '',
            venueManagerContactInfo: eventDetails.venueManagerContactInfo ?? '',
            venueDoorCode: eventDetails.venueDoorCode ?? '',
            eventGuestCount: eventDetails.eventGuestCount ?? '',
            eventNotes: eventDetails.eventNotes ?? '',
            floorPlanCanvasHeight: eventDetails.floorPlanCanvasHeight ?? '',
            floorPlanCanvasWidth: eventDetails.floorPlanCanvasWidth ?? '',
            floorPlanRoomHeight: eventDetails.floorPlanRoomHeight ?? '',
            floorPlanRoomWidth: eventDetails.floorPlanRoomWidth ?? '',
            floorPlan: eventDetails.floorPlan ?? '',
            floorPlanNotes: eventDetails.floorPlanNotes ?? '',
            selectedGalleryImages: eventDetails.selectedGalleryImages ?? '[]',
            otherEventOptions: eventDetails.otherEventOptions ?? '[]',
            tableRequirements: eventDetails.tableRequirements ?? '[]',
            utensilsAndEquipmentList: eventDetails.utensilsAndEquipmentList ?? '[]',
            eventStaffList: eventDetails.eventStaffList ?? '[]',
            invoice: eventDetails.invoice ?? '[]',
            eventPartsTimeLine: eventDetails.eventPartsTimeLine ?? '[]',
            eventDetailsSellerNotes: eventDetails.eventDetailsSellerNotes ?? '',
            coupon: eventDetails.coupon ?? '',
            couponDescription: eventDetails.couponDescription ?? '',
            couponExpirationDate: eventDetails.couponExpirationDate ?? ''
        });
    }, [eventDetails]);
    //console.log('eventDetails', eventDetails);
    //console.log('state', state);

    const inputHandle = (e) => {
        setState(prev => ({ ...prev, [e.target.name]: e.target.value }));
        setEventDetailsSaved(false);
    };

    const update_event_details_local = (e) => {
        e.preventDefault();
        const submitter = e.nativeEvent.submitter;
        if (submitter && submitter.name !== 'btnSaveEventDetails') return;

        const updatedState = {
            ...state,
            eventName: toTitleCase(state.eventName),
            venueName: toTitleCase(state.venueName),
            selectedGalleryImages: JSON.stringify(selectedItemsSelectedGalleryImages),
            otherEventOptions: JSON.stringify(selectedItemsOtherEventOptions),
        };
        setState(updatedState);

        if (!userInfo) { navigate('/login'); return; }

        dispatch(update_event_details_not_deposit({
            customerId: userInfo.id,
            eventName: updatedState.eventName,
            selectedSellerPackage: updatedState.selectedSellerPackage,
            venueName: updatedState.venueName,
            venueAddress: updatedState.venueAddress,
            eventType: updatedState.eventType,
            eventDate: updatedState.eventDate,
            eventStartTime: updatedState.eventStartTime,
            eventServiceType: updatedState.eventServiceType,
            eventPlaceSettings: updatedState.eventPlaceSettings,
            eventGuestTableclothColor: updatedState.eventGuestTableclothColor,
            eventBuffetTableclothColor: updatedState.eventBuffetTableclothColor,
            eventNapkinColor: updatedState.eventNapkinColor,
            venueManagerContactInfo: updatedState.venueManagerContactInfo,
            venueDoorCode: updatedState.venueDoorCode,
            eventGuestCount: updatedState.eventGuestCount,
            selectedGalleryImages: updatedState.selectedGalleryImages,
            eventNotes: updatedState.eventNotes,
            otherEventOptions: updatedState.otherEventOptions,
            tableRequirements: updatedState.tableRequirements,
            utensilsAndEquipmentList: updatedState.utensilsAndEquipmentList,
            eventStaffList: updatedState.eventStaffList,
            invoice: updatedState.invoice,
            eventPartsTimeLine: updatedState.eventPartsTimeLine,
            coupon: updatedState.coupon,
            couponDescription: updatedState.couponDescription,
            couponExpirationDate: updatedState.couponExpirationDate
        }));

        const {
            eventName, venueName, venueAddress, eventType, eventDate, eventStartTime,
            eventServiceType, eventPlaceSettings, eventGuestTableclothColor,
            eventBuffetTableclothColor, eventNapkinColor, venueManagerContactInfo, eventGuestCount
        } = updatedState;

        const baseValid = eventName && venueName && venueAddress && eventType && eventDate; // && eventStartTime;

        if (!isDeposit && !isBalance) {
            if (baseValid && eventServiceType && eventPlaceSettings && eventGuestTableclothColor &&
                eventBuffetTableclothColor && eventNapkinColor && venueManagerContactInfo && eventGuestCount) {
                setRes(true);
            }
        } else if (baseValid) {
            setRes(true);
        }

        setEventDetailsSaved(true);
    };

    const place_order_local = () => {
        if (!isDeposit && !isBalance && !sellerBoolShowSitePayments) {
            //console.log('place_order_local');
            dispatch(place_order({
                customerId: userInfo?.id,
                customerName: userInfo?.name,
                customerEmail: userInfo?.email,
                customerPhone: formatPhoneNumber(userInfo?.phoneNumber),
                orderType, price, products,
                eventDetailsInfo: state
            }));
        }
        navigate('/payment', { state: { 
            price, products, eventDetailsInfo: state, isDeposit, isBalance, items 
        } });
    };

    useEffect(() => {
        if (successMessage) { toast.success(successMessage); dispatch(messageClear()); }
        if (errorMessage) { toast.error(errorMessage); dispatch(messageClear()); }
    }, [successMessage, errorMessage, dispatch]);

    return (
        <div className=''>
            <Header />
            <section className='flex-1'>
                <div className=''>
                    <ShopBanner
                        homePage={'Home'} homeLink={'/'}
                        currentPageTop={''} currentPageTopLink={''}
                        currentPageBottom1={`My ${sellerProductPluralTerm}`} currentPageBottomLink1={'/cart'}
                        currentPageBottom2={'Event Details'} currentPageBottomLink2={''}
                    />
                </div>
                <div className="w-full mt-0" style={{ backgroundColor: sellerComponentBackgroundColor }}>
                    <div className='rounded-2xl w-[85%] lg:w-[90%] md:w-[90%] sm:w-[95%] mx-auto bg-white'>
                        <div className='rounded-2xl w-full flex flex-wrap gap-6 items-start relative border p-5'
                            style={{ 
                                backgroundColor: sellerColorLight,
                                borderColor: sellerColorDark 
                            }}>

                            {/* ── LEFT: Form / Summary ── */}
                            <div className='flex-1 min-w-0 md-lg:w-full'>
                                <div
                                    className='rounded-xl border shadow-sm overflow-hidden'
                                    style={{ 
                                        borderColor: sellerColorDark,
                                        borderTop: `6px solid ${sellerColorDark}`,
                                        backgroundColor: '#fff' 
                                    }}>
                                    {/* Panel header flex items-center justify-between px-6 py-3 */}
                                    <div
                                        className='relative grid grid-cols-3 sm:grid-cols-1 items-center gap-3 px-6 py-3'
                                        style={{
                                            borderBottom: `1px solid ${sellerColorMedium}`,
                                            backgroundColor: sellerColorLight
                                        }}>

                                        {/* Col 1: icon + title */}
                                        <div className="flex items-center gap-2 min-w-0 pr-16 sm:pr-0">
                                            <div>
                                                <TbListDetails size={54} style={{ color: sellerColorDark }} />
                                            </div>
                                            <div>
                                                <div
                                                    className="text-xl font-bold tracking-tight leading-none"
                                                    style={{ color: sellerColorDark }}>
                                                    Event Details
                                                </div>
                                                <span className='text-[13px]' style={{ color: sellerRequiredFieldColor }}>
                                                    <span className='font-bold'>*</span> Required Fields
                                                </span>
                                            </div>
                                        </div>
                                        {/* Col 2: product/price */}
                                        {(isDeposit || isBalance) && (
                                            <div>
                                                <div className='font-bold text-sm sm:text-base' style={{ color: sellerColorDark }}>
                                                    {productName} {currencyFormat.format(price)}
                                                </div>
                                                <div className='text-xs sm:text-sm' style={{ color: sellerColorMedium }}>
                                                    We Need A Few Pieces Of Information
                                                </div>
                                            </div>
                                        )}

                                        {/* Col 3 / Pill: pinned top-right on mobile, grid-placed on desktop */}
                                        <div className='absolute top-3 right-6 sm:static sm:justify-self-end'>
                                            <div
                                                className={`inline-flex items-center gap-1 px-2 py-1 rounded-xl text-[12px]
                                                    font-semibold whitespace-nowrap transition-colors duration-300 border
                                                    ${eventDetailsSaved
                                                        ? 'bg-green-200 text-green-700 border-green-700'
                                                        : 'bg-red-200 text-red-700 border-red-700'
                                                    }`}>
                                                <FiSave size={14} />
                                                {eventDetailsSaved ? 'Details Saved' : 'Details Unsaved'}
                                            </div>
                                        </div>
                                    </div>
                                    <DiagnosticInfo parentPage={'EventDetails.jsx'} isDeposit={isDeposit} />
                                        
                                    {
                                    // <div
                                    //     className='flex sm:flex-nowrap items-start sm:items-center justify-between gap-3 px-6 py-3'
                                    //     style={{ 
                                    //         borderBottom: `1px solid ${colorMedium}`, 
                                    //         backgroundColor: colorLight 
                                    //     }}>
                                    //     <div className="flex items-center gap-2 border-none border-black">
                                    //         <div>
                                    //             <TbListDetails size={54} style={{ color: colorDark }} />
                                    //         </div>
                                    //         <div>
                                    //             <div
                                    //                 className="text-xl font-bold tracking-tight leading-none"
                                    //                 style={{ color: colorDark }}>
                                    //                 Event Details
                                    //             </div>
                                    //             <span className='text-[13px]' style={{ color: sellerRequiredFieldColor }}>
                                    //                 <span className='font-bold'>*</span> Required Fields
                                    //             </span>
                                    //         </div>
                                    //     </div>
                                    //     <div className='flex items-center w-[380px] sm:w-full gap-3'>
                                    //         <div className={` ${isDeposit || isBalance ? '' : 'hidden'}
                                    //             border-none border-black `}>
                                    //             <div className='font-bold' style={{ color: colorDark }}>
                                    //                 {productName} {currencyFormat.format(price)}
                                    //             </div>
                                    //             <div className='text-sm' style={{ color: colorMedium }}>
                                    //                 We Need A Few Pieces Of Information
                                    //             </div>
                                    //         </div>
                                    //         {/* Save status pill */}
                                    //         <div className='shrink-0'>
                                    //             <div
                                    //                 className={`inline-flex items-center gap-1 px-2 py-1 rounded-xl text-[12px]
                                    //                     font-semibold whitespace-nowrap transition-colors duration-300 border
                                    //                     ${eventDetailsSaved
                                    //                         ? 'bg-green-200 text-green-700 border border-green-700'
                                    //                         : 'bg-red-200 text-red-700 border border-red-700'
                                    //                     }`}>
                                    //                 <FiSave size={42} />
                                    //                 {eventDetailsSaved ? 'Details Saved' : 'Details Unsaved'}
                                    //             </div>
                                    //         </div>
                                    //     </div>
                                    // </div>
                                    }
                                    <div className='px-6 py-5' style={{ color: colorDark }}>
                                        {!res ? (
                                            <form onSubmit={update_event_details_local}>
                                                {/* ── Section: Event Identity ── */}
                                                <SectionHeading label="Event Identity" color={colorMedium} />
                                                <div className='grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
                                                    <Field label="Event Name" required showRequired="always">
                                                        <StyledInput
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required
                                                            onChange={inputHandle} value={state.eventName}
                                                            name="eventName" id="eventName" type="text"
                                                            placeholder='e.g. Bar Mitzvah of Ari Cohen'
                                                        />
                                                    </Field>
                                                    <Field label="Package">
                                                        <StyledSelect
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required
                                                            onChange={inputHandle} value={state.selectedSellerPackage}
                                                            name="selectedSellerPackage" id="selectedSellerPackage">
                                                            <option value='None'>Choose Package</option>
                                                            {sellerPackages.map((item, index) => (
                                                                <option key={index} value={item.title}>{item.title}</option>
                                                            ))}
                                                        </StyledSelect>
                                                    </Field>
                                                    <Field label="Event Type" required showRequired="always">
                                                        <StyledSelect
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required
                                                            onChange={inputHandle} value={state.eventType}
                                                            name="eventType" id="eventType">
                                                            <option value="">Event Type</option>
                                                            {[...sellerArrEventTypes].sort().map((ev, i) => (
                                                                <option key={i} value={ev}>{ev}</option>
                                                            ))}
                                                        </StyledSelect>
                                                    </Field>
                                                </div>

                                                {/* ── Section: Venue ── */}
                                                <SectionHeading label="Venue" color={colorMedium} />
                                                <div className='grid grid-cols-4 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
                                                    <Field label="Venue Name" required showRequired="always">
                                                        <StyledInput
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight}
                                                            required
                                                            onChange={inputHandle} value={state.venueName}
                                                            name="venueName" id="venueName" type="text"
                                                            placeholder='e.g. Cong Adath Israel'
                                                        />
                                                    </Field>
                                                    <Field label="Venue Address" required showRequired="always">
                                                        <StyledInput
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required
                                                            onChange={inputHandle} value={state.venueAddress}
                                                            name="venueAddress" id="venueAddress" type="text"
                                                            placeholder='Full address, city, state, zip'
                                                        />
                                                    </Field>
                                                    <Field
                                                        label="Venue Manager"
                                                        required={!isDeposit && !isBalance}
                                                        isDeposit={isDeposit}
                                                        isBalance={isBalance}
                                                        showRequired={!isDeposit}>
                                                        <StyledInput
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required={!isDeposit && !isBalance}
                                                            onChange={inputHandle} value={state.venueManagerContactInfo}
                                                            name="venueManagerContactInfo" id="venueManagerContactInfo"
                                                            type="text" placeholder='Name / Phone or N/A'
                                                        />
                                                    </Field>
                                                    <Field label="Door Code">
                                                        <StyledInput
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            onChange={inputHandle} value={state.venueDoorCode}
                                                            name="venueDoorCode" id="venueDoorCode"
                                                            type="text" placeholder='If applicable'
                                                        />
                                                    </Field>
                                                </div>
                                                
                                                {/* ── Section: Date & Service ── */}
                                                <SectionHeading label="Date & Service" color={colorMedium} />
                                                <div className='grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
                                                    <Field label="Event Date" required showRequired="always">
                                                        <StyledInput
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required
                                                            onChange={inputHandle} value={state.eventDate}
                                                            name="eventDate" id="eventDate" type="date"
                                                        />
                                                    </Field>
                                                    <Field label="Start Time" 
                                                        required={!isDeposit && !isBalance} 
                                                        showRequired={!isDeposit && !isBalance}>
                                                        <StyledInput
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required={!isDeposit && !isBalance}
                                                            onChange={inputHandle} value={state.eventStartTime}
                                                            name="eventStartTime" id="eventStartTime" type="time"
                                                        />
                                                    </Field>
                                                    <Field
                                                        label={`Guest Count${sellerMinGuestCount !== '1' ? ` (Min ${sellerMinGuestCount})` : ''}`}
                                                        required={!isDeposit && !isBalance}
                                                        isDeposit={isDeposit && !isBalance}
                                                        showRequired={!isDeposit && !isBalance}>
                                                        <StyledInput
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required={!isDeposit && !isBalance}
                                                            min={!isDeposit && !isBalance ? sellerMinGuestCount : 0}
                                                            onChange={inputHandle} value={state.eventGuestCount}
                                                            type="number" name="eventGuestCount" id="eventGuestCount"
                                                            placeholder='Number of guests'
                                                        />
                                                    </Field>
                                                </div>
                                                <div className='grid grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
                                                    <Field
                                                        label="Place Settings"
                                                        required={!isDeposit && !isBalance}
                                                        isDeposit={isDeposit}
                                                        isBalance={isBalance}
                                                        showRequired={!isDeposit && !isBalance}>
                                                        <StyledSelect
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required={!isDeposit && !isBalance}
                                                            onChange={inputHandle} value={state.eventPlaceSettings}
                                                            name="eventPlaceSettings" id="eventPlaceSettings">
                                                            <option value="">Place Settings</option>
                                                            {sellerPlaceSettings?.split(';').map((p2, i) => (
                                                                <option key={i} value={p2}>{p2}</option>
                                                            ))}
                                                        </StyledSelect>
                                                    </Field>
                                                    <Field
                                                        label="Service Type"
                                                        required={!isDeposit && !isBalance}
                                                        isDeposit={isDeposit}
                                                        isBalance={isBalance}
                                                        showRequired={!isDeposit && !isBalance}>
                                                        <StyledSelect
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required={!isDeposit && !isBalance}
                                                            onChange={inputHandle} value={state.eventServiceType}
                                                            name="eventServiceType" id="eventServiceType">
                                                            <option value="">Service Type</option>
                                                            {sellerServiceTypes?.split(';').map((p2, i) => (
                                                                <option key={i} value={p2}>{p2}</option>
                                                            ))}
                                                        </StyledSelect>
                                                    </Field>
                                                </div>

                                                {/* ── Section: Table & Linen ── */}
                                                <SectionHeading label="Table & Linen" color={colorMedium} />
                                                <div className='grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
                                                    <Field
                                                        label="Guest Tablecloth Color"
                                                        required={!isDeposit && !isBalance}
                                                        isDeposit={isDeposit}
                                                        isBalance={isBalance}
                                                        showRequired={!isDeposit && !isBalance}>
                                                        <StyledSelect
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required={!isDeposit && !isBalance}
                                                            onChange={inputHandle} value={state.eventGuestTableclothColor}
                                                            name="eventGuestTableclothColor" id="eventGuestTableclothColor">
                                                            <option value="">Guest Tablecloth</option>
                                                            <option value="None">None</option>
                                                            {sellerClothColors?.split(';').sort().map((c, i) => (
                                                                <option key={i} value={c}>{c}</option>
                                                            ))}
                                                        </StyledSelect>
                                                    </Field>
                                                    <Field
                                                        label="Buffet Tablecloth Color"
                                                        required={!isDeposit && !isBalance}
                                                        isDeposit={isDeposit}
                                                        isBalance={isBalance}
                                                        showRequired={!isDeposit && !isBalance}>
                                                        <StyledSelect
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required={!isDeposit && !isBalance}
                                                            onChange={inputHandle} value={state.eventBuffetTableclothColor}
                                                            name="eventBuffetTableclothColor" id="eventBuffetTableclothColor">
                                                            <option value="">Buffet Tablecloth</option>
                                                            <option value="None">None</option>
                                                            {sellerClothColors?.split(';').sort().map((c, i) => (
                                                                <option key={i} value={c}>{c}</option>
                                                            ))}
                                                        </StyledSelect>
                                                    </Field>
                                                    <Field
                                                        label="Napkin Color"
                                                        required={!isDeposit && !isBalance}
                                                        isDeposit={isDeposit}
                                                        isBalance={isBalance}
                                                        showRequired={!isDeposit && !isBalance}>
                                                        <StyledSelect
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight} 
                                                            required={!isDeposit && !isBalance}
                                                            onChange={inputHandle} value={state.eventNapkinColor}
                                                            name="eventNapkinColor" id="eventNapkinColor">
                                                            <option value="">Napkin Color</option>
                                                            <option value="None">None</option>
                                                            {sellerClothColors?.split(';').sort().map((c, i) => (
                                                                <option key={i} value={c}>{c}</option>
                                                            ))}
                                                        </StyledSelect>
                                                    </Field>
                                                </div>

                                                {/* ── Section: Extras ── */}
                                                {(arrOtherEventOptionsChoicesNew.length > 0 || allSiteGalleryImagesNew.length > 0) && (
                                                    <>
                                                        <SectionHeading label="Extras" color={colorMedium} />
                                                        <div className='flex md:flex-col gap-6 mb-2'>
                                                            {arrOtherEventOptionsChoicesNew.length > 0 && (
                                                                <div className='w-full'>
                                                                    <label className='text-[12px] font-semibold uppercase tracking-wider opacity-80 block mb-1'>
                                                                        Other Event Options
                                                                    </label>
                                                                    <div className='w-full max-w-[320px]'>
                                                                        <MultiSelectDropdown
                                                                            id="multiSelectedOtherEventOptions"
                                                                            items={arrOtherEventOptionsChoicesNew}
                                                                            initialSelectedItems={selectedItemsOtherEventOptions}
                                                                            onSelectionChange={setSelectedItemsOtherEventOptions}
                                                                            title="Select Other Event Options"
                                                                        />
                                                                        <SelectedItemsPanel
                                                                            title="Selected:"
                                                                            items={selectedItemsOtherEventOptions}
                                                                            colorDark={colorDark}
                                                                            colorMedium={colorMedium}
                                                                            colorLight={colorLight}
                                                                            emptyLabel="No options selected."
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {allSiteGalleryImagesNew.length > 0 && (
                                                                <div className='w-full'>
                                                                    <label className='text-[12px] font-semibold uppercase tracking-wider opacity-80 block mb-1'>
                                                                        <Link to='/galleryImages' className='hover:underline underline-offset-2'>
                                                                            Table Settings
                                                                            <span className='normal-case font-normal ml-1'>(Gallery)</span>
                                                                        </Link>
                                                                    </label>
                                                                    <div className='w-full max-w-[320px]'>
                                                                        <MultiSelectDropdown
                                                                            id="multiSelectedGalleryImages"
                                                                            items={allSiteGalleryImagesNew}
                                                                            initialSelectedItems={selectedItemsSelectedGalleryImages}
                                                                            onSelectionChange={setSelectedItemsSelectedGalleryImages}
                                                                            title="Select Table Settings"
                                                                        />
                                                                        <SelectedItemsPanel
                                                                            title="Selected:"
                                                                            items={selectedItemsSelectedGalleryImages}
                                                                            colorDark={colorDark}
                                                                            colorMedium={colorMedium}
                                                                            colorLight={colorLight}
                                                                            emptyLabel="No table settings selected."
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                )}

                                                {/* ── Section: Notes ── */}
                                                <SectionHeading label="Notes" color={colorMedium} />
                                                <div className='mb-2'>
                                                    <Field label="Event Notes">
                                                        <StyledTextarea
                                                            colorDark={colorDark}
                                                            colorMedium={colorMedium}
                                                            colorLight={colorLight}
                                                            onChange={inputHandle} value={state.eventNotes}
                                                            name="eventNotes" id="eventNotes"
                                                            placeholder="Food sensitivities, special requests, anything else we should know…"
                                                        />
                                                    </Field>
                                                </div>

                                                {/* Save button + Floor Planner button */}
                                                <div className='mt-3 flex flex-wrap items-center gap-3'>
                                                    <button
                                                        id="btnSaveEventDetails"
                                                        name="btnSaveEventDetails"
                                                        type="submit"
                                                        className='inline-flex items-center gap-1 px-6 py-2.5 rounded-lg text-white text-md font-semibold tracking-wide
                                                            transition-all duration-200 hover:opacity-90 hover:shadow-md active:scale-[0.98]'
                                                        style={{ backgroundColor: colorDark }}>
                                                        <FiSave size={18} />
                                                        Save Event Details
                                                    </button>

                                                    <button
                                                        type="button"
                                                        id="btnOpenFloorPlanner"
                                                        name="btnOpenFloorPlanner"
                                                        onClick={() => setShowFloorPlanner(true)}
                                                        className='inline-flex items-center gap-1 px-6 py-2.5 rounded-lg text-md font-semibold tracking-wide
                                                            border transition-all duration-200 hover:opacity-90 hover:shadow-md active:scale-[0.98]'
                                                        style={{ 
                                                            color: colorDark, 
                                                            borderColor: colorDark, 
                                                            backgroundColor: colorLight 
                                                        }}>
                                                        <MdOutlineTableBar size={22} />
                                                        View Floor Planner
                                                    </button>
                                                </div>

                                            </form>
                                        ) : (
                                            /* ── Summary view ── */
                                            <div className='flex flex-col gap-1'>
                                                <div className='flex items-center gap-2 mb-4'>
                                                    <FaCircleCheck className='text-green-500' size={26} />
                                                    <h2 className='font-semibold text-[16px]'>
                                                        {state.eventName} — Event Details Confirmed
                                                    </h2>
                                                </div>

                                                <SectionHeading label="Event Identity" color={colorMedium} />
                                                <div className='grid grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-2 mb-1'>
                                                    <SummaryItem label="Package" value={state.selectedSellerPackage} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                    <SummaryItem label="Event Type" value={eventDetails?.eventType} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                    <SummaryItem
                                                        label="Date & Time"
                                                        value={Moment(`${eventDetails?.eventDate} ${eventDetails?.eventStartTime}`).format('ddd MM/DD/yyyy h:mm A')}
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                    <SummaryItem label="Deposit" value={eventDetails?.depositGiven ? 'Given' : 'Not Given'} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                </div>

                                                <SectionHeading label="Venue" color={colorMedium} />
                                                <div className='grid grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-2 mb-1'>
                                                    <SummaryItem label="Venue" value={state.venueName} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                    <SummaryItem label="Address" value={eventDetails?.venueAddress} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                    <SummaryItem label="Door Code" value={eventDetails?.venueDoorCode} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                    <SummaryItem label="Manager" value={eventDetails?.venueManagerContactInfo} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                </div>

                                                <SectionHeading label="Service" color={colorMedium} />
                                                <div className='grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2 mb-1'>
                                                    <SummaryItem label="Service Type" value={eventDetails?.eventServiceType} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                    <SummaryItem label="Place Settings" value={eventDetails?.eventPlaceSettings} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                    <SummaryItem label="Guest Count" value={eventDetails?.eventGuestCount} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                </div>

                                                <SectionHeading label="Linen" color={colorMedium} />
                                                <div className='grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2 mb-1'>
                                                    <SummaryItem label="Guest Tablecloth" value={eventDetails?.eventGuestTableclothColor} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                    <SummaryItem label="Buffet Tablecloth" value={eventDetails?.eventBuffetTableclothColor} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                    <SummaryItem label="Napkin Color" value={eventDetails?.eventNapkinColor} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                </div>

                                                <SectionHeading label="Notes" color={colorMedium} />
                                                <div className='mb-3'>
                                                    <SummaryItem label="Event Notes" value={eventDetails?.eventNotes || '—'} 
                                                        colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
                                                </div>

                                                <div className='grid grid-cols-2 sm:grid-cols-1 gap-3 mb-4'>
                                                    <div>
                                                        <SelectedItemsPanel
                                                            title="Other Event Options"
                                                            items={selectedItemsOtherEventOptions}
                                                            colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}
                                                            emptyLabel="None selected."
                                                        />
                                                    </div>
                                                    <div>
                                                        <SelectedItemsPanel
                                                            title="Table Settings"
                                                            items={selectedItemsSelectedGalleryImages}
                                                            colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}
                                                            emptyLabel="None selected."
                                                        />
                                                    </div>
                                                </div>
                                                <div className=' grid grid-cols-1 sm:grid-cols-1 gap-3 mb-4'>
                                                    {(() => {
                                                        const savedGalleryImages = eventDetails?.selectedGalleryImages
                                                            ? JSON.parse(eventDetails.selectedGalleryImages)
                                                            : [];
                                                        return savedGalleryImages.length > 0 ? (
                                                            <div className="grid grid-cols-4 gap-2">
                                                                {savedGalleryImages.map((item) => (
                                                                    <div key={item.id}
                                                                        className="gallery-images__saved-card flex flex-col items-center border"
                                                                        style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                                        <img src={item.image} alt={item.name} />
                                                                        <div className="w-full px-2 py-1 text-center text-[13px] font-medium"
                                                                            style={{ 
                                                                                color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                                                backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
                                                                            }}>
                                                                            {item.name}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <p className="italic font-normal text-[13px]" style={{ color: sellerPrimaryColor1 }}>
                                                                {/*No saved settings found.*/}
                                                            </p>
                                                        );
                                                    })()}
                                                </div>
                                                
                                                <button
                                                    onClick={() => setRes(false)}
                                                    className='inline-flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold
                                                        border transition-all duration-200 hover:opacity-80'
                                                    style={{ 
                                                        borderColor: colorDark, 
                                                        color: colorDark, 
                                                        backgroundColor: colorLight 
                                                    }}>
                                                    Edit Event Details
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* ── RIGHT: Sticky Summary panel ── */}
                            <div className='w-[280px] md-lg:w-full flex-shrink-0 self-start sticky top-4'>
                                <div>
                                    <div
                                        className='rounded-xl border shadow-sm overflow-hidden'
                                        style={{ 
                                            backgroundColor: '#fff', 
                                            borderColor: colorDark,
                                            borderTop: `6px solid ${colorDark}`,
                                        }}>
                                        {/* Panel header */}
                                        <div
                                            className='flex items-center gap-2 px-5 py-6'
                                            style={{ 
                                                borderBottom: `1px solid ${colorMedium}`, 
                                                backgroundColor: colorLight
                                            }}>
                                            <MdOutlineRestaurantMenu size={28} style={{ color: colorDark }} />
                                            <span className='font-bold text-[19px] tracking-tight' 
                                                style={{ color: colorDark }}>
                                                {!isDeposit ? sellerProductPluralTerm : ''} Summary
                                            </span>
                                        </div>

                                        <div className='px-5 py-4 flex flex-col gap-3'>
                                            {/* Items / price line */}
                                            <div
                                                className='flex justify-between items-center pb-3'
                                                style={{ borderBottom: `1px solid ${colorMedium}` }}>
                                                <span className='text-sm font-medium' style={{ color: colorDark }}>
                                                    {priceLine}
                                                </span>
                                                {(isDeposit || isBalance || sellerBoolShowSitePayments) && (
                                                    <span className='text-sm font-semibold' style={{ color: colorDark }}>
                                                        {currencyFormat.format(price)}
                                                    </span>
                                                )}
                                            </div>

                                            {sellerBoolShowSitePayments && (
                                                <div className='flex justify-between items-center'>
                                                    <span className='text-xs uppercase tracking-widest' 
                                                        style={{ color: colorMedium }}>Total</span>
                                                    <span className='text-lg font-bold' style={{ color: colorDark }}>
                                                        {currencyFormat.format(price)}
                                                    </span>
                                                </div>
                                            )}

                                            {(!sellerBoolShowSitePayments && !isDeposit) && (
                                                <p className='text-[12px] leading-relaxed' style={{ color: colorMedium }}>
                                                    Once you finalize your order, we'll send you a final quote.
                                                </p>
                                            )}

                                            {!res && (
                                                <p className='text-[12px] leading-relaxed' style={{ color: colorDark }}>
                                                    Complete and save the event details form to enable checkout.
                                                </p>
                                            )}

                                            {/* Finalize button */}
                                            <button
                                                onClick={place_order_local}
                                                disabled={!res}
                                                className={`flex items-center justify-center gap-2 w-full py-2.5 rounded-lg
                                                    text-[14px] font-bold uppercase tracking-wide text-white
                                                    transition-all duration-200
                                                    ${res
                                                        ? 'hover:opacity-90 hover:shadow-md active:scale-[0.98]'
                                                        : 'opacity-40 cursor-not-allowed'
                                                    }`}
                                                style={{ backgroundColor: res ? colorDark : '#9CA3AF' }}>
                                                <MdOutlineRestaurantMenu size={24} />
                                                {finalizeLine}
                                            </button>

                                            {sellerEnvironment !== 'Prod' && (
                                                <button
                                                    onClick={place_order_local}
                                                    className='w-full py-2 rounded-lg text-[12px] font-semibold uppercase tracking-wide
                                                        transition-all duration-200 hover:opacity-80'
                                                    style={{
                                                        color: colorDark,
                                                        border: `2px solid ${colorDark}`,
                                                        backgroundColor: colorLight
                                                    }}>
                                                    Test Payment
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />

            {/* ── Floor Planner Modal ── */}
            {showFloorPlanner && (
                <div
                    className='fixed inset-0 z-50 flex items-center justify-center p-4'
                    style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                    onClick={() => setShowFloorPlanner(false)}>
                    <div
                        className='bg-white rounded-2xl shadow-xl max-w-6xl max-h-[90vh] overflow-hidden flex flex-col'
                        style={{ borderTop: `6px solid ${colorDark}` }}
                        onClick={(e) => e.stopPropagation()}>
                        <div
                            className='flex items-center justify-between px-5 py-3 flex-shrink-0'
                            style={{ backgroundColor: colorLight, borderBottom: `0px solid ${colorMedium}` }}>
                            <span className='flex text-[20px] gap-1 font-bold uppercase tracking-wider' style={{ color: colorDark }}>
                                <MdOutlineTableBar size={32} />
                                View Floor Planner
                                <span className='text-[15px] text-white px-3 py-1 rounded-lg font-bold uppercase tracking-wider' 
                                    style={{ backgroundColor: colorDark }}>
                                    <a className='flex items-center gap-1' href="/customerDashboard/FloorPlanner">
                                        <MdOutlineTableBar size={22} />
                                        Edit Floor Planner   
                                    </a>
                                </span>
                            </span>
                            
                            <button
                                type="button"
                                onClick={() => setShowFloorPlanner(false)}
                                className='text-[13px] font-semibold uppercase tracking-wide px-3 py-1 rounded-md hover:opacity-80'
                                style={{ color: 'red', border: `2px solid ${'red'}` }}>
                                Close
                            </button>
                        </div>
                        <div className='flex-1 overflow-auto p-2' style={{ backgroundColor: colorLight }}>
                            <FloorPlanner showTopMenu={false} showSideMenu={false} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EventDetails;





//before FloorPlanner
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useLocation, useNavigate } from 'react-router-dom';

// import { FaCircleCheck } from "react-icons/fa6";
// import { FiSave } from 'react-icons/fi';
// import { TbListDetails } from "react-icons/tb";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { GiCheckMark } from "react-icons/gi";

// import { place_order } from '../store/reducers/orderReducer';
// import {
//     update_event_details_not_deposit,
//     get_event_details,
//     messageClear
// } from '../store/reducers/eventDetailsReducer';
// import { get_sellerPackages_webSiteOrigin } from '../store/reducers/sellerPackageReducer';

// import FloorPlanner from '../components/customerDashboard/FloorPlannerGridSize';
// import { currencyFormat } from '../components/CurrencyFormat';
// import { toTitleCase } from '../components/toTitleCase';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import ShopBanner from '../components/ShopBanner';
// import GetSellerConfig from '../components/GetSellerConfig';
// import MultiSelectDropdown from '../components/MultiSelectDropdown';
// import DiagnosticInfo from '../components/DiagnosticInfo';

// import Moment from 'moment';
// import toast from 'react-hot-toast';

// import config from '../config';

// const safeJsonParse = (value, fallback = []) => {
//     if (!value) return fallback;
//     try {
//         const parsed = JSON.parse(value);
//         return Array.isArray(parsed) ? parsed : fallback;
//     } catch {
//         return fallback;
//     }
// };

// const SummaryItem = ({ label, value, colorDark, colorMedium, colorLight }) => (
//     <div
//         className='flex flex-col gap-0.5 mb-2 w-full px-3 py-2 rounded-md'
//         style={{ 
//             borderLeft: `3px solid ${colorDark}`, 
//             backgroundColor: colorLight 
//         }}>
//         <span className='text-[11px] font-semibold uppercase tracking-widest' style={{ colorMedium }}>{label}</span>
//         <span className='text-[14px] font-medium'>{value}</span>
//     </div>
// );

// const SelectedItemsPanel = ({ title, items, colorDark, colorMedium, colorLight, emptyLabel }) => (
//     <div
//         className="mt-1 p-2 rounded-md h-[80px] overflow-y-auto"
//         style={{ 
//             backgroundColor: colorLight, 
//             border: `1px solid ${colorDark}` 
//         }}>
//         <div className="text-[11px] font-semibold uppercase tracking-widest mb-1" style={{ colorMedium }}>
//             {title}
//         </div>
//         {items.length > 0 ? (
//             <ul className="space-y-1">
//                 {items.map((item) => (
//                     <li key={item.id} className="flex items-center justify-between w-full px-1 py-0 text-left">
//                         <span className="font-normal text-[13px]" style={{ colorDark }}>{item.name}</span>
//                         <GiCheckMark className="w-4 h-4 text-green-500 inline-block" />
//                     </li>
//                 ))}
//             </ul>
//         ) : (
//             <p className="italic text-[12px]" style={{ colorMedium }}>{emptyLabel}</p>
//         )}
//     </div>
// );

// // Section divider with heading
// const SectionHeading = ({ label, color }) => (
//     <div className='flex items-center gap-3 mt-5 mb-3'>
//         <span
//             className='text-[11px] font-bold uppercase tracking-widest whitespace-nowrap'
//             style={{ color: color }}>
//             {label}
//         </span>
//         <div className='flex-1 h-px' style={{ backgroundColor: color }} />
//     </div>
// );

// // Styled input — injects glow on focus via inline style trick + Tailwind
// const fieldBase =
//     'w-full px-3 py-2 rounded-md border bg-white text-sm transition-all duration-200 outline-none placeholder-gray-300';

// const StyledInput = ({ colorDark, colorMedium, colorLight, ...props }) => (
//     <input
//         {...props}
//         className={fieldBase}
//         style={{
//             borderColor: colorMedium , 
//             color: colorDark, 
//             backgroundColor: 'white'
//         }}
//         onFocus={e => {
//             e.target.style.borderColor = colorDark;
//             e.target.style.backgroundColor = colorLight;
//             //e.target.style.boxShadow = `0 0 0 3px ${color}20`;
//         }}
//         onBlur={e => {
//             e.target.style.borderColor = colorMedium;
//             e.target.style.backgroundColor = 'white';
//             //e.target.style.boxShadow = 'none';
//         }}
//     />    
// );

// const StyledSelect = ({ colorDark, colorMedium, colorLight, children, ...props }) => (
//     <select
//         {...props}
//         className={fieldBase + ' cursor-pointer'}
//         style={{
//             borderColor: colorMedium, 
//             color: colorDark, 
//             backgroundColor: 'white',
//             height: '38px',
//         }}
//         onFocus={e => {
//             e.target.style.borderColor = colorDark;
//             e.target.style.backgroundColor = colorLight;
//             //e.target.style.boxShadow = `0 0 0 3px ${color}20`;
//         }}
//         onBlur={e => {
//             e.target.style.borderColor = colorMedium;
//             e.target.style.backgroundColor = 'white';
//             //e.target.style.boxShadow = 'none';
//         }}>
//         {children}
//     </select>
// );

// const StyledTextarea = ({ colorDark, colorMedium, colorLight, ...props }) => (
//     <textarea
//         {...props}
//         className={fieldBase + ' h-[110px] resize-none'}
//         style={{
//             borderColor: colorDark,
//             color: colorDark,
//             backgroundColor: 'white',
//         }}
//         onFocus={e => {
//             e.target.style.borderColor = colorDark;
//             e.target.style.backgroundColor = colorLight;
//             //e.target.style.boxShadow = `0 0 0 3px ${color}20`;
//         }}
//         onBlur={e => {
//             e.target.style.borderColor = colorDark;
//             e.target.style.backgroundColor = 'white';
//             //e.target.style.boxShadow = 'none';
//         }}
//     />
// );

// // Field wrapper with label
// const Field = ({ label, required, isDeposit, showRequired = true, children }) => (
//     <div className='flex flex-col gap-1 w-full'>
//        <div className='text-[12px] h-[26px] flex items-center justify-items-center
//             font-semibold uppercase tracking-wider border-none border-red-700'>
//             {label}
//             {required && (showRequired === 'always' || (showRequired && !isDeposit)) && (
//                 <span className='mt-0 ml-1 text-[18px] text-red-400 font-bold leading-none self-center'>*</span>
//             )}
//         </div>
//         {children}
//     </div>
// );

// const EventDetails = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;
//     const sellerArrEventTypes = config.STR_ARR_FRONTEND_EVENT_TYPES;
//     const sellerBoolShowBrand = config.BOOL_SHOW_PRODUCT_BRAND;
//     const sellerRequiredFieldColor = config.STR_FRONTEND_REQUIRED_FIELD_COLOR;
//     const sellerEnvironment = config.STR_ENVIRONMENT;
    
//     const { userInfo } = useSelector(state => state.auth);
//     const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
//     const { sellerPackages } = useSelector(state => state.sellerPackage);
//     const { allSiteGalleryImages } = useSelector(state => state.home);

//     const allSiteGalleryImagesNew = (allSiteGalleryImages ?? []).map(({ _id, caption, image }) => ({
//         id: _id, name: caption, image
//     }));

//     const {
//         sellerPrimaryColor1, sellerSecondaryColor1,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerClothColors, sellerMinGuestCount, sellerServiceTypes, sellerProductPluralTerm,
//         sellerPlaceSettings, sellerOtherEventOptionsChoices, sellerBoolShowSitePayments,
//     } = GetSellerConfig();

//     const colorDark = sellerPrimaryColor1 + sellerColorSuffixDark;
//     const colorMedium = sellerPrimaryColor1 + sellerColorSuffixMedium;
//     const colorLight = sellerPrimaryColor1 + sellerColorSuffixLight;
    
//     const [selectedItemsSelectedGalleryImages, setSelectedItemsSelectedGalleryImages] = useState([]);
//     const [selectedItemsOtherEventOptions, setSelectedItemsOtherEventOptions] = useState([]);
//     const [eventDetailsSaved, setEventDetailsSaved] = useState(true);
//     const [res, setRes] = useState(false);

//     const arrOtherEventOptionsChoicesNew = (sellerOtherEventOptionsChoices
//         ? sellerOtherEventOptionsChoices.split(';')
//         : []
//     ).map((item, index) => ({ id: index, name: item }));

//     const { state: { products, price, items } } = useLocation();
//     const productName = products[0]?.products[0]?.productInfo.name;
//     //const isDeposit = productName === 'Deposit';
//     const isDeposit = productName.includes('Deposit') || productName === 'Deposit';

//     //console.log(`isDeposit is a ${typeof isDeposit}:`, isDeposit);
    
//     const orderType = 'Menu Order';

//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     useEffect(() => {
//         if (userInfo?.id) dispatch(get_event_details(userInfo.id));
//     }, [dispatch, userInfo?.id]);

//     useEffect(() => {
//         dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL));
//     }, [dispatch, sellerFrontendURL]);

//     useEffect(() => {
//         if (eventDetails) {
//             setSelectedItemsSelectedGalleryImages(safeJsonParse(eventDetails.selectedGalleryImages));
//             setSelectedItemsOtherEventOptions(safeJsonParse(eventDetails.otherEventOptions));
//         }
//     }, [eventDetails]);

//     const [state, setState] = useState({
//         depositGiven: isDeposit, eventName: '', selectedSellerPackage: 'None',
//         venueName: '', venueAddress: '', eventType: '', eventDate: '',
//         eventStartTime: '', eventServiceType: '', eventPlaceSettings: '',
//         eventGuestTableclothColor: '', eventBuffetTableclothColor: '',
//         eventNapkinColor: '', venueManagerContactInfo: '', venueDoorCode: '',
//         eventGuestCount: '', eventNotes: '',
//         floorPlanCanvasHeight: '', floorPlanCanvasWidth: '',
//         floorPlanRoomHeight: '', floorPlanRoomWidth: '',
//         floorPlan: '', floorPlanNotes: '',
//         selectedGalleryImages: '[]', otherEventOptions: '[]',
//         tableRequirements: '[]', utensilsAndEquipmentList: '[]', eventStaffList: '[]'
//     });

//     useEffect(() => {
//         if (!eventDetails) return;
//         setState({
//             depositGiven: eventDetails.depositGiven,
//             eventName: eventDetails.eventName ?? '',
//             selectedSellerPackage: eventDetails.selectedSellerPackage ?? 'None',
//             venueName: eventDetails.venueName ?? '',
//             venueAddress: eventDetails.venueAddress ?? '',
//             eventType: eventDetails.eventType ?? '',
//             eventDate: eventDetails.eventDate ?? '',
//             eventStartTime: eventDetails.eventStartTime ?? '',
//             eventServiceType: eventDetails.eventServiceType ?? '',
//             eventPlaceSettings: eventDetails.eventPlaceSettings ?? '',
//             eventGuestTableclothColor: eventDetails.eventGuestTableclothColor ?? '',
//             eventBuffetTableclothColor: eventDetails.eventBuffetTableclothColor ?? '',
//             eventNapkinColor: eventDetails.eventNapkinColor ?? '',
//             venueManagerContactInfo: eventDetails.venueManagerContactInfo ?? '',
//             venueDoorCode: eventDetails.venueDoorCode ?? '',
//             eventGuestCount: eventDetails.eventGuestCount ?? '',
//             eventNotes: eventDetails.eventNotes ?? '',
//             floorPlanCanvasHeight: eventDetails.floorPlanCanvasHeight ?? '',
//             floorPlanCanvasWidth: eventDetails.floorPlanCanvasWidth ?? '',
//             floorPlanRoomHeight: eventDetails.floorPlanRoomHeight ?? '',
//             floorPlanRoomWidth: eventDetails.floorPlanRoomWidth ?? '',
//             floorPlan: eventDetails.floorPlan ?? '',
//             floorPlanNotes: eventDetails.floorPlanNotes ?? '',
//             selectedGalleryImages: eventDetails.selectedGalleryImages ?? '[]',
//             otherEventOptions: eventDetails.otherEventOptions ?? '[]',
//             tableRequirements: eventDetails.tableRequirements ?? '[]',
//             utensilsAndEquipmentList: eventDetails.utensilsAndEquipmentList ?? '[]',
//             eventStaffList: eventDetails.eventStaffList ?? '[]'
//         });
//     }, [eventDetails]);

//     const inputHandle = (e) => {
//         setState(prev => ({ ...prev, [e.target.name]: e.target.value }));
//         setEventDetailsSaved(false);
//     };

//     const update_event_details_local = (e) => {
//         e.preventDefault();
//         const submitter = e.nativeEvent.submitter;
//         if (submitter && submitter.name !== 'btnSaveEventDetails') return;

//         const updatedState = {
//             ...state,
//             eventName: toTitleCase(state.eventName),
//             venueName: toTitleCase(state.venueName),
//             selectedGalleryImages: JSON.stringify(selectedItemsSelectedGalleryImages),
//             otherEventOptions: JSON.stringify(selectedItemsOtherEventOptions),
//         };
//         setState(updatedState);

//         if (!userInfo) { navigate('/login'); return; }

//         dispatch(update_event_details_not_deposit({
//             customerId: userInfo.id,
//             eventName: updatedState.eventName,
//             selectedSellerPackage: updatedState.selectedSellerPackage,
//             venueName: updatedState.venueName,
//             venueAddress: updatedState.venueAddress,
//             eventType: updatedState.eventType,
//             eventDate: updatedState.eventDate,
//             eventStartTime: updatedState.eventStartTime,
//             eventServiceType: updatedState.eventServiceType,
//             eventPlaceSettings: updatedState.eventPlaceSettings,
//             eventGuestTableclothColor: updatedState.eventGuestTableclothColor,
//             eventBuffetTableclothColor: updatedState.eventBuffetTableclothColor,
//             eventNapkinColor: updatedState.eventNapkinColor,
//             venueManagerContactInfo: updatedState.venueManagerContactInfo,
//             venueDoorCode: updatedState.venueDoorCode,
//             eventGuestCount: updatedState.eventGuestCount,
//             selectedGalleryImages: updatedState.selectedGalleryImages,
//             eventNotes: updatedState.eventNotes,
//             otherEventOptions: updatedState.otherEventOptions,
//             tableRequirements: updatedState.tableRequirements,
//             utensilsAndEquipmentList: updatedState.utensilsAndEquipmentList,
//             eventStaffList: updatedState.eventStaffList
//         }));

//         const {
//             eventName, venueName, venueAddress, eventType, eventDate, eventStartTime,
//             eventServiceType, eventPlaceSettings, eventGuestTableclothColor,
//             eventBuffetTableclothColor, eventNapkinColor, venueManagerContactInfo, eventGuestCount
//         } = updatedState;

//         const baseValid = eventName && venueName && venueAddress && eventType && eventDate; // && eventStartTime;

//         if (!isDeposit) {
//             if (baseValid && eventServiceType && eventPlaceSettings && eventGuestTableclothColor &&
//                 eventBuffetTableclothColor && eventNapkinColor && venueManagerContactInfo && eventGuestCount) {
//                 setRes(true);
//             }
//         } else if (baseValid) {
//             setRes(true);
//         }

//         setEventDetailsSaved(true);
//     };

//     const place_order_local = () => {
//         if (!isDeposit && !sellerBoolShowSitePayments) {
//             //console.log('place_order_local');
//             dispatch(place_order({
//                 customerId: userInfo.id,
//                 customerName: userInfo.name,
//                 customerEmail: userInfo.email,
//                 customerPhone: userInfo.phoneNumber,
//                 orderType, price, products,
//                 eventDetailsInfo: state
//             }));
//         }
//         navigate('/payment', { state: { 
//             price, products, eventDetailsInfo: state, isDeposit, items 
//         } });
//     };

//     useEffect(() => {
//         if (successMessage) { toast.success(successMessage); dispatch(messageClear()); }
//         if (errorMessage) { toast.error(errorMessage); dispatch(messageClear()); }
//     }, [successMessage, errorMessage, dispatch]);

//     return (
//         <div className=''>
//             <Header />
//             <section className='flex-1'>
//                 <div className=''>
//                     <ShopBanner
//                         homePage={'Home'} homeLink={'/'}
//                         currentPageTop={''} currentPageTopLink={''}
//                         currentPageBottom1={`My ${sellerProductPluralTerm}`} currentPageBottomLink1={'/cart'}
//                         currentPageBottom2={'Event Details'} currentPageBottomLink2={''}
//                     />
//                 </div>
//                 <div className="w-full mt-0" style={{ backgroundColor: sellerComponentBackgroundColor }}>
//                     <div className='rounded-2xl w-[85%] lg:w-[90%] md:w-[90%] sm:w-[95%] mx-auto bg-white'>
//                         <div className='rounded-2xl w-full flex flex-wrap gap-6 items-start relative border p-5'
//                             style={{ 
//                                 backgroundColor: colorLight,
//                                 borderColor: colorDark 
//                             }}>

//                             {/* ── LEFT: Form / Summary ── */}
//                             <div className='flex-1 min-w-0 md-lg:w-full'>
//                                 <div
//                                     className='rounded-xl border shadow-sm overflow-hidden'
//                                     style={{ 
//                                         borderColor: colorDark,
//                                         borderTop: `6px solid ${colorDark}`,
//                                         backgroundColor: '#fff' 
//                                     }}>
//                                     {/* Panel header */}
//                                     <div
//                                         className='flex items-center justify-between px-6 py-3'
//                                         style={{ 
//                                             borderBottom: `1px solid ${colorMedium}`, 
//                                             backgroundColor: colorLight 
//                                         }}>
//                                         <div className="flex items-center gap-2 mb-0 pb-0">
//                                             <div>
//                                                 <TbListDetails size={54} style={{ color: colorDark }} />
//                                             </div>
//                                             <div>
//                                                 <div
//                                                     className="text-xl font-bold tracking-tight leading-none"
//                                                     style={{ color: colorDark }}>
//                                                     Event Details
//                                                 </div>
//                                                 <span className='text-[13px]' style={{ color: sellerRequiredFieldColor }}>
//                                                     <span className='font-bold'>*</span> Required Fields
//                                                 </span>
//                                             </div>
//                                         </div>
//                                         <div className='flex items-center gap-3'>
//                                             <DiagnosticInfo parentPage={'EventDetails.jsx'} isDeposit={isDeposit} />
//                                             {/* Save status pill */}
//                                             <div className='flex items-center gap-2 mb-5'>
//                                                 <div
//                                                     className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-semibold transition-colors duration-300
//                                                         ${eventDetailsSaved
//                                                             ? 'bg-green-100 text-green-700 border border-green-700'
//                                                             : 'bg-amber-100 text-amber-700 border border-amber-700'
//                                                         }`}>
//                                                     <FiSave size={13} />
//                                                     {eventDetailsSaved ? 'Event Details Saved' : 'Unsaved Changes'}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className='px-6 py-5' style={{ color: colorDark }}>
//                                         {!res ? (
//                                             <form onSubmit={update_event_details_local}>
//                                                 {/* ── Section: Event Identity ── */}
//                                                 <SectionHeading label="Event Identity" color={colorMedium} />
//                                                 <div className='grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
//                                                     <Field label="Event Name" required showRequired="always">
//                                                         <StyledInput
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required
//                                                             onChange={inputHandle} value={state.eventName}
//                                                             name="eventName" id="eventName" type="text"
//                                                             placeholder='e.g. Bar Mitzvah of Ari Cohen'
//                                                         />
//                                                     </Field>
//                                                     <Field label="Package">
//                                                         <StyledSelect
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required
//                                                             onChange={inputHandle} value={state.selectedSellerPackage}
//                                                             name="selectedSellerPackage" id="selectedSellerPackage">
//                                                             <option value='None'>Choose Package</option>
//                                                             {sellerPackages.map((item, index) => (
//                                                                 <option key={index} value={item.title}>{item.title}</option>
//                                                             ))}
//                                                         </StyledSelect>
//                                                     </Field>
//                                                     <Field label="Event Type" required showRequired="always">
//                                                         <StyledSelect
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required
//                                                             onChange={inputHandle} value={state.eventType}
//                                                             name="eventType" id="eventType">
//                                                             <option value="">Event Type</option>
//                                                             {[...sellerArrEventTypes].sort().map((ev, i) => (
//                                                                 <option key={i} value={ev}>{ev}</option>
//                                                             ))}
//                                                         </StyledSelect>
//                                                     </Field>
//                                                 </div>

//                                                 {/* ── Section: Venue ── */}
//                                                 <SectionHeading label="Venue" color={colorMedium} />
//                                                 <div className='grid grid-cols-4 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
//                                                     <Field label="Venue Name" required showRequired="always">
//                                                         <StyledInput
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight}
//                                                             required
//                                                             onChange={inputHandle} value={state.venueName}
//                                                             name="venueName" id="venueName" type="text"
//                                                             placeholder='e.g. Cong Adath Israel'
//                                                         />
//                                                     </Field>
//                                                     <Field label="Venue Address" required showRequired="always">
//                                                         <StyledInput
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required
//                                                             onChange={inputHandle} value={state.venueAddress}
//                                                             name="venueAddress" id="venueAddress" type="text"
//                                                             placeholder='Full address, city, state, zip'
//                                                         />
//                                                     </Field>
//                                                     <Field
//                                                         label="Venue Manager"
//                                                         required={!isDeposit}
//                                                         isDeposit={isDeposit}
//                                                         showRequired={!isDeposit}>
//                                                         <StyledInput
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required={!isDeposit}
//                                                             onChange={inputHandle} value={state.venueManagerContactInfo}
//                                                             name="venueManagerContactInfo" id="venueManagerContactInfo"
//                                                             type="text" placeholder='Name / Phone or N/A'
//                                                         />
//                                                     </Field>
//                                                     <Field label="Door Code">
//                                                         <StyledInput
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             onChange={inputHandle} value={state.venueDoorCode}
//                                                             name="venueDoorCode" id="venueDoorCode"
//                                                             type="text" placeholder='If applicable'
//                                                         />
//                                                     </Field>
//                                                 </div>
                                                
//                                                 {/* ── Section: Date & Service ── */}
//                                                 <SectionHeading label="Date & Service" color={colorMedium} />
//                                                 <div className='grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
//                                                     <Field label="Event Date" required showRequired="always">
//                                                         <StyledInput
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required
//                                                             onChange={inputHandle} value={state.eventDate}
//                                                             name="eventDate" id="eventDate" type="date"
//                                                         />
//                                                     </Field>
//                                                     <Field label="Start Time" 
//                                                         required={!isDeposit} 
//                                                         showRequired={!isDeposit}>
//                                                         <StyledInput
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required={!isDeposit}
//                                                             onChange={inputHandle} value={state.eventStartTime}
//                                                             name="eventStartTime" id="eventStartTime" type="time"
//                                                         />
//                                                     </Field>
//                                                     <Field
//                                                         label={`Guest Count${sellerMinGuestCount !== '1' ? ` (Min ${sellerMinGuestCount})` : ''}`}
//                                                         required={!isDeposit}
//                                                         isDeposit={isDeposit}
//                                                         showRequired={!isDeposit}>
//                                                         <StyledInput
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required={!isDeposit}
//                                                             min={!isDeposit ? sellerMinGuestCount : 0}
//                                                             onChange={inputHandle} value={state.eventGuestCount}
//                                                             type="number" name="eventGuestCount" id="eventGuestCount"
//                                                             placeholder='Number of guests'
//                                                         />
//                                                     </Field>
//                                                 </div>
//                                                 <div className='grid grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
//                                                     <Field
//                                                         label="Place Settings"
//                                                         required={!isDeposit}
//                                                         isDeposit={isDeposit}
//                                                         showRequired={!isDeposit}>
//                                                         <StyledSelect
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required={!isDeposit}
//                                                             onChange={inputHandle} value={state.eventPlaceSettings}
//                                                             name="eventPlaceSettings" id="eventPlaceSettings">
//                                                             <option value="">Place Settings</option>
//                                                             {sellerPlaceSettings?.split(';').map((p2, i) => (
//                                                                 <option key={i} value={p2}>{p2}</option>
//                                                             ))}
//                                                         </StyledSelect>
//                                                     </Field>
//                                                     <Field
//                                                         label="Service Type"
//                                                         required={!isDeposit}
//                                                         isDeposit={isDeposit}
//                                                         showRequired={!isDeposit}>
//                                                         <StyledSelect
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required={!isDeposit}
//                                                             onChange={inputHandle} value={state.eventServiceType}
//                                                             name="eventServiceType" id="eventServiceType">
//                                                             <option value="">Service Type</option>
//                                                             {sellerServiceTypes?.split(';').map((p2, i) => (
//                                                                 <option key={i} value={p2}>{p2}</option>
//                                                             ))}
//                                                         </StyledSelect>
//                                                     </Field>
//                                                 </div>

//                                                 {/* ── Section: Table & Linen ── */}
//                                                 <SectionHeading label="Table & Linen" color={colorMedium} />
//                                                 <div className='grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
//                                                     <Field
//                                                         label="Guest Tablecloth Color"
//                                                         required={!isDeposit}
//                                                         isDeposit={isDeposit}
//                                                         showRequired={!isDeposit}>
//                                                         <StyledSelect
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required={!isDeposit}
//                                                             onChange={inputHandle} value={state.eventGuestTableclothColor}
//                                                             name="eventGuestTableclothColor" id="eventGuestTableclothColor">
//                                                             <option value="">Guest Tablecloth</option>
//                                                             <option value="None">None</option>
//                                                             {sellerClothColors?.split(';').sort().map((c, i) => (
//                                                                 <option key={i} value={c}>{c}</option>
//                                                             ))}
//                                                         </StyledSelect>
//                                                     </Field>
//                                                     <Field
//                                                         label="Buffet Tablecloth Color"
//                                                         required={!isDeposit}
//                                                         isDeposit={isDeposit}
//                                                         showRequired={!isDeposit}>
//                                                         <StyledSelect
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required={!isDeposit}
//                                                             onChange={inputHandle} value={state.eventBuffetTableclothColor}
//                                                             name="eventBuffetTableclothColor" id="eventBuffetTableclothColor">
//                                                             <option value="">Buffet Tablecloth</option>
//                                                             <option value="None">None</option>
//                                                             {sellerClothColors?.split(';').sort().map((c, i) => (
//                                                                 <option key={i} value={c}>{c}</option>
//                                                             ))}
//                                                         </StyledSelect>
//                                                     </Field>
//                                                     <Field
//                                                         label="Napkin Color"
//                                                         required={!isDeposit}
//                                                         isDeposit={isDeposit}
//                                                         showRequired={!isDeposit}>
//                                                         <StyledSelect
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight} 
//                                                             required={!isDeposit}
//                                                             onChange={inputHandle} value={state.eventNapkinColor}
//                                                             name="eventNapkinColor" id="eventNapkinColor">
//                                                             <option value="">Napkin Color</option>
//                                                             <option value="None">None</option>
//                                                             {sellerClothColors?.split(';').sort().map((c, i) => (
//                                                                 <option key={i} value={c}>{c}</option>
//                                                             ))}
//                                                         </StyledSelect>
//                                                     </Field>
//                                                 </div>

//                                                 {/* ── Section: Extras ── */}
//                                                 {(arrOtherEventOptionsChoicesNew.length > 0 || allSiteGalleryImagesNew.length > 0) && (
//                                                     <>
//                                                         <SectionHeading label="Extras" color={colorMedium} />
//                                                         <div className='flex md:flex-col gap-6 mb-2'>
//                                                             {arrOtherEventOptionsChoicesNew.length > 0 && (
//                                                                 <div className='w-full'>
//                                                                     <label className='text-[12px] font-semibold uppercase tracking-wider opacity-80 block mb-1'>
//                                                                         Other Event Options
//                                                                     </label>
//                                                                     <div className='w-full max-w-[320px]'>
//                                                                         <MultiSelectDropdown
//                                                                             id="multiSelectedOtherEventOptions"
//                                                                             items={arrOtherEventOptionsChoicesNew}
//                                                                             initialSelectedItems={selectedItemsOtherEventOptions}
//                                                                             onSelectionChange={setSelectedItemsOtherEventOptions}
//                                                                             title="Select Other Event Options"
//                                                                         />
//                                                                         <SelectedItemsPanel
//                                                                             title="Selected:"
//                                                                             items={selectedItemsOtherEventOptions}
//                                                                             colorDark={colorDark}
//                                                                             colorMedium={colorMedium}
//                                                                             colorLight={colorLight}
//                                                                             emptyLabel="No options selected."
//                                                                         />
//                                                                     </div>
//                                                                 </div>
//                                                             )}
//                                                             {allSiteGalleryImagesNew.length > 0 && (
//                                                                 <div className='w-full'>
//                                                                     <label className='text-[12px] font-semibold uppercase tracking-wider opacity-80 block mb-1'>
//                                                                         <Link to='/galleryImages' className='hover:underline underline-offset-2'>
//                                                                             Table Settings
//                                                                             <span className='normal-case font-normal ml-1'>(Gallery)</span>
//                                                                         </Link>
//                                                                     </label>
//                                                                     <div className='w-full max-w-[320px]'>
//                                                                         <MultiSelectDropdown
//                                                                             id="multiSelectedGalleryImages"
//                                                                             items={allSiteGalleryImagesNew}
//                                                                             initialSelectedItems={selectedItemsSelectedGalleryImages}
//                                                                             onSelectionChange={setSelectedItemsSelectedGalleryImages}
//                                                                             title="Select Table Settings"
//                                                                         />
//                                                                         <SelectedItemsPanel
//                                                                             title="Selected:"
//                                                                             items={selectedItemsSelectedGalleryImages}
//                                                                             colorDark={colorDark}
//                                                                             colorMedium={colorMedium}
//                                                                             colorLight={colorLight}
//                                                                             emptyLabel="No table settings selected."
//                                                                         />
//                                                                     </div>
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                     </>
//                                                 )}

//                                                 {/* ── Section: Notes ── */}
//                                                 <SectionHeading label="Notes" color={colorMedium} />
//                                                 <div className='mb-2'>
//                                                     <Field label="Event Notes">
//                                                         <StyledTextarea
//                                                             colorDark={colorDark}
//                                                             colorMedium={colorMedium}
//                                                             colorLight={colorLight}
//                                                             onChange={inputHandle} value={state.eventNotes}
//                                                             name="eventNotes" id="eventNotes"
//                                                             placeholder="Food sensitivities, special requests, anything else we should know…"
//                                                         />
//                                                     </Field>
//                                                 </div>

//                                                 {/* Save button */}
//                                                 <div className='mt-3'>
//                                                     <button
//                                                         id="btnSaveEventDetails"
//                                                         name="btnSaveEventDetails"
//                                                         type="submit"
//                                                         className='inline-flex items-center gap-2 px-6 py-2.5 rounded-lg text-white text-md font-semibold tracking-wide
//                                                             transition-all duration-200 hover:opacity-90 hover:shadow-md active:scale-[0.98]'
//                                                         style={{ backgroundColor: colorDark }}>
//                                                         <FiSave size={18} />
//                                                         Save Event Details
//                                                     </button>
//                                                 </div>
//                                             </form>
//                                         ) : (
//                                             /* ── Summary view ── */
//                                             <div className='flex flex-col gap-1'>
//                                                 <div className='flex items-center gap-2 mb-4'>
//                                                     <FaCircleCheck className='text-green-500' size={26} />
//                                                     <h2 className='font-semibold text-[16px]'>
//                                                         {state.eventName} — Event Details Confirmed
//                                                     </h2>
//                                                 </div>

//                                                 <SectionHeading label="Event Identity" color={colorMedium} />
//                                                 <div className='grid grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-2 mb-1'>
//                                                     <SummaryItem label="Package" value={state.selectedSellerPackage} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                     <SummaryItem label="Event Type" value={eventDetails?.eventType} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                     <SummaryItem
//                                                         label="Date & Time"
//                                                         value={Moment(`${eventDetails?.eventDate} ${eventDetails?.eventStartTime}`).format('ddd MM/DD/yyyy h:mm A')}
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                     <SummaryItem label="Deposit" value={eventDetails?.depositGiven ? 'Given' : 'Not Given'} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                 </div>

//                                                 <SectionHeading label="Venue" color={colorMedium} />
//                                                 <div className='grid grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-2 mb-1'>
//                                                     <SummaryItem label="Venue" value={state.venueName} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                     <SummaryItem label="Address" value={eventDetails?.venueAddress} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                     <SummaryItem label="Door Code" value={eventDetails?.venueDoorCode} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                     <SummaryItem label="Manager" value={eventDetails?.venueManagerContactInfo} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                 </div>

//                                                 <SectionHeading label="Service" color={colorMedium} />
//                                                 <div className='grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2 mb-1'>
//                                                     <SummaryItem label="Service Type" value={eventDetails?.eventServiceType} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                     <SummaryItem label="Place Settings" value={eventDetails?.eventPlaceSettings} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                     <SummaryItem label="Guest Count" value={eventDetails?.eventGuestCount} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                 </div>

//                                                 <SectionHeading label="Linen" color={colorMedium} />
//                                                 <div className='grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2 mb-1'>
//                                                     <SummaryItem label="Guest Tablecloth" value={eventDetails?.eventGuestTableclothColor} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                     <SummaryItem label="Buffet Tablecloth" value={eventDetails?.eventBuffetTableclothColor} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                     <SummaryItem label="Napkin Color" value={eventDetails?.eventNapkinColor} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                 </div>

//                                                 <SectionHeading label="Notes" color={colorMedium} />
//                                                 <div className='mb-3'>
//                                                     <SummaryItem label="Event Notes" value={eventDetails?.eventNotes || '—'} 
//                                                         colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight} />
//                                                 </div>

//                                                 <div className='grid grid-cols-2 sm:grid-cols-1 gap-3 mb-4'>
//                                                     <div>
//                                                         <SelectedItemsPanel
//                                                             title="Other Event Options"
//                                                             items={selectedItemsOtherEventOptions}
//                                                             colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}
//                                                             emptyLabel="None selected."
//                                                         />
//                                                     </div>
//                                                     <div>
//                                                         <SelectedItemsPanel
//                                                             title="Table Settings"
//                                                             items={selectedItemsSelectedGalleryImages}
//                                                             colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}
//                                                             emptyLabel="None selected."
//                                                         />
//                                                     </div>
//                                                 </div>

//                                                 <button
//                                                     onClick={() => setRes(false)}
//                                                     className='inline-flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold
//                                                         border transition-all duration-200 hover:opacity-80'
//                                                     style={{ 
//                                                         borderColor: colorDark, 
//                                                         color: colorDark, 
//                                                         backgroundColor: colorLight 
//                                                     }}>
//                                                     Edit Event Details
//                                                 </button>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* ── RIGHT: Sticky Summary panel ── */}
//                             <div className='w-[280px] md-lg:w-full flex-shrink-0 self-start sticky top-4'>
//                                 <div>
//                                     <div
//                                         className='rounded-xl border shadow-sm overflow-hidden'
//                                         style={{ 
//                                             backgroundColor: '#fff', 
//                                             borderColor: colorDark,
//                                             borderTop: `6px solid ${colorDark}`,
//                                         }}>
//                                         {/* Panel header */}
//                                         <div
//                                             className='flex items-center gap-2 px-5 py-6'
//                                             style={{ 
//                                                 borderBottom: `1px solid ${colorMedium}`, 
//                                                 backgroundColor: colorLight
//                                             }}>
//                                             <MdOutlineRestaurantMenu size={28} style={{ color: colorDark }} />
//                                             <span className='font-bold text-[19px] tracking-tight' 
//                                                 style={{ color: colorDark }}>
//                                                 {!isDeposit ? sellerProductPluralTerm : ''} Summary
//                                             </span>
//                                         </div>

//                                         <div className='px-5 py-4 flex flex-col gap-3'>
//                                             {/* Items / price line */}
//                                             <div
//                                                 className='flex justify-between items-center pb-3'
//                                                 style={{ borderBottom: `1px solid ${colorMedium}` }}>
//                                                 <span className='text-sm font-medium' style={{ color: colorDark }}>
//                                                     {!isDeposit ? `${items} Items` : 'Deposit'}
//                                                 </span>
//                                                 {(isDeposit || sellerBoolShowSitePayments) && (
//                                                     <span className='text-sm font-semibold' style={{ color: colorDark }}>
//                                                         {currencyFormat.format(price)}
//                                                     </span>
//                                                 )}
//                                             </div>

//                                             {sellerBoolShowSitePayments && (
//                                                 <div className='flex justify-between items-center'>
//                                                     <span className='text-xs uppercase tracking-widest' 
//                                                         style={{ color: colorMedium }}>Total</span>
//                                                     <span className='text-lg font-bold' style={{ color: colorDark }}>
//                                                         {currencyFormat.format(price)}
//                                                     </span>
//                                                 </div>
//                                             )}

//                                             {(!sellerBoolShowSitePayments && !isDeposit) && (
//                                                 <p className='text-[12px] leading-relaxed' style={{ color: colorMedium }}>
//                                                     Once you finalize your order, we'll send you a final quote. rewrewr
//                                                 </p>
//                                             )}

//                                             {!res && (
//                                                 <p className='text-[12px] leading-relaxed' style={{ color: colorDark }}>
//                                                     Complete and save the event details form to enable checkout.
//                                                 </p>
//                                             )}

//                                             {/* Finalize button */}
//                                             <button
//                                                 onClick={place_order_local}
//                                                 disabled={!res}
//                                                 className={`flex items-center justify-center gap-2 w-full py-2.5 rounded-lg
//                                                     text-[14px] font-bold uppercase tracking-wide text-white
//                                                     transition-all duration-200
//                                                     ${res
//                                                         ? 'hover:opacity-90 hover:shadow-md active:scale-[0.98]'
//                                                         : 'opacity-40 cursor-not-allowed'
//                                                     }`}
//                                                 style={{ backgroundColor: res ? colorDark : '#9CA3AF' }}>
//                                                 <MdOutlineRestaurantMenu size={24} />
//                                                 {!isDeposit ? 'Finalize My Menu' : 'Finalize My Deposit'}
                                                
//                                             </button>

//                                             {sellerEnvironment !== 'Prod' && (
//                                                 <button
//                                                     onClick={place_order_local}
//                                                     className='w-full py-2 rounded-lg text-[12px] font-semibold uppercase tracking-wide
//                                                         transition-all duration-200 hover:opacity-80'
//                                                     style={{
//                                                         color: colorDark,
//                                                         border: `2px solid ${colorDark}`,
//                                                         backgroundColor: colorLight
//                                                     }}>
//                                                     Test Payment
//                                                 </button>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//             <Footer />
//         </div>
//     );
// };

// export default EventDetails;






//refactored before redesign
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useLocation, useNavigate } from 'react-router-dom';

// import { FaCircleCheck } from "react-icons/fa6";
// import { FiSave } from 'react-icons/fi';
// import { TbListDetails } from "react-icons/tb";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { GiCheckMark } from "react-icons/gi";

// import { place_order } from '../store/reducers/orderReducer';
// import {
//     update_event_details_not_deposit,
//     get_event_details,
//     messageClear
// } from '../store/reducers/eventDetailsReducer';
// import { get_sellerPackages_webSiteOrigin } from '../store/reducers/sellerPackageReducer';

// import { currencyFormat } from '../components/CurrencyFormat';
// import { toTitleCase } from '../components/toTitleCase';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import ShopBanner from '../components/ShopBanner';
// import GetSellerConfig from '../components/GetSellerConfig';
// import MultiSelectDropdown from '../components/MultiSelectDropdown';

// import Moment from 'moment';
// import toast from 'react-hot-toast';

// import config from '../config';

// // Safely parse JSON, falling back to an empty array
// const safeJsonParse = (value, fallback = []) => {
//     if (!value) return fallback;
//     try {
//         const parsed = JSON.parse(value);
//         return Array.isArray(parsed) ? parsed : fallback;
//     } catch {
//         return fallback;
//     }
// };

// // Reusable summary detail box used throughout the "res" summary view
// const SummaryItem = ({ label, value, color }) => (
//     <div className='flex flex-col gap-1 mb-2 w-full border p-1' style={{ borderColor: color }}>
//         <span className='font-semibold'>{label}</span>
//         {value}
//     </div>
// );

// // Reusable "selected items" list panel
// const SelectedItemsPanel = ({ title, items, color, emptyLabel }) => (
//     <div className="p-2 bg-gray-50 border border-gray-200 rounded-md h-[80px] overflow-y-auto" style={{ color }}>
//         <div className="text-[14px] font-semibold mb-0">{title}</div>
//         {items.length > 0 ? (
//             <ul className="space-y-1">
//                 {items.map((item) => (
//                     <li
//                         key={item.id}
//                         className="flex items-center justify-between w-full px-1 py-0 text-left border-none"
//                         style={{ borderColor: color }}
//                     >
//                         <span className="font-normal text-[14px]" style={{ color }}>
//                             {item.name}
//                         </span>
//                         <GiCheckMark className="w-5 h-5 text-green-500 inline-block" />
//                     </li>
//                 ))}
//             </ul>
//         ) : (
//             <p className="italic font-normal text-[13px]">{emptyLabel}</p>
//         )}
//     </div>
// );

// const EventDetails = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;
//     const sellerArrEventTypes = config.STR_ARR_FRONTEND_EVENT_TYPES;
//     const sellerBoolShowBrand = config.BOOL_SHOW_PRODUCT_BRAND;
//     const sellerRequiredFieldColor = config.STR_FRONTEND_REQUIRED_FIELD_COLOR;
//     const sellerEnvironment = config.STR_ENVIRONMENT;

//     const { userInfo } = useSelector(state => state.auth);
//     const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
//     const { sellerPackages } = useSelector(state => state.sellerPackage);
//     const { allSiteGalleryImages } = useSelector(state => state.home);

//     const allSiteGalleryImagesNew = (allSiteGalleryImages ?? []).map(({ _id, caption, image }) => ({
//         id: _id,
//         name: caption,
//         image
//     }));

//     const {
//         sellerPrimaryColor1, sellerSecondaryColor1,
//         sellerClothColors, sellerMinGuestCount, sellerServiceTypes,
//         sellerPlaceSettings, sellerOtherEventOptionsChoices, sellerBoolShowSitePayments,
//     } = GetSellerConfig();

//     const [selectedItemsSelectedGalleryImages, setSelectedItemsSelectedGalleryImages] = useState([]);
//     const [selectedItemsOtherEventOptions, setSelectedItemsOtherEventOptions] = useState([]);
//     const [eventDetailsSaved, setEventDetailsSaved] = useState(true);
//     const [res, setRes] = useState(false);

//     const arrOtherEventOptionsChoicesNew = (sellerOtherEventOptionsChoices
//         ? sellerOtherEventOptionsChoices.split(';')
//         : []
//     ).map((item, index) => ({ id: index, name: item }));

//     const { state: { products, price, items } } = useLocation();

//     const productName = products[0].products[0].productInfo.name;
//     const isDeposit = productName === 'Deposit';
//     const orderType = 'Menu Order';

//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     useEffect(() => {
//         if (userInfo?.id) {
//             dispatch(get_event_details(userInfo.id));
//         }
//     }, [dispatch, userInfo?.id]);

//     useEffect(() => {
//         dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL));
//     }, [dispatch, sellerFrontendURL]);

//     useEffect(() => {
//         if (eventDetails) {
//             setSelectedItemsSelectedGalleryImages(safeJsonParse(eventDetails.selectedGalleryImages));
//             setSelectedItemsOtherEventOptions(safeJsonParse(eventDetails.otherEventOptions));
//         }
//     }, [eventDetails]);

//     const [state, setState] = useState({
//         depositGiven: isDeposit, eventName: '', selectedSellerPackage: 'None', venueName: '', venueAddress: '',
//         eventType: '', eventDate: '', eventStartTime: '', eventServiceType: '', eventPlaceSettings: '',
//         eventGuestTableclothColor: '', eventBuffetTableclothColor: '',
//         eventNapkinColor: '', venueManagerContactInfo: '', venueDoorCode: '', eventGuestCount: '', eventNotes: '',
//         floorPlanCanvasHeight: '', floorPlanCanvasWidth: '', floorPlanRoomHeight: '', floorPlanRoomWidth: '',
//         floorPlan: '', floorPlanNotes: '',
//         selectedGalleryImages: '[]', otherEventOptions: '[]', tableRequirements: '[]',
//         utensilsAndEquipmentList: '[]', eventStaffList: '[]'
//     });

//     useEffect(() => {
//         if (!eventDetails) return;
//         setState({
//             depositGiven: eventDetails.depositGiven,
//             eventName: eventDetails.eventName ?? '',
//             selectedSellerPackage: eventDetails.selectedSellerPackage ?? 'None',
//             venueName: eventDetails.venueName ?? '',
//             venueAddress: eventDetails.venueAddress ?? '',
//             eventType: eventDetails.eventType ?? '',
//             eventDate: eventDetails.eventDate ?? '',
//             eventStartTime: eventDetails.eventStartTime ?? '',
//             eventServiceType: eventDetails.eventServiceType ?? '',
//             eventPlaceSettings: eventDetails.eventPlaceSettings ?? '',
//             eventGuestTableclothColor: eventDetails.eventGuestTableclothColor ?? '',
//             eventBuffetTableclothColor: eventDetails.eventBuffetTableclothColor ?? '',
//             eventNapkinColor: eventDetails.eventNapkinColor ?? '',
//             venueManagerContactInfo: eventDetails.venueManagerContactInfo ?? '',
//             venueDoorCode: eventDetails.venueDoorCode ?? '',
//             eventGuestCount: eventDetails.eventGuestCount ?? '',
//             eventNotes: eventDetails.eventNotes ?? '',
//             floorPlanCanvasHeight: eventDetails.floorPlanCanvasHeight ?? '',
//             floorPlanCanvasWidth: eventDetails.floorPlanCanvasWidth ?? '',
//             floorPlanRoomHeight: eventDetails.floorPlanRoomHeight ?? '',
//             floorPlanRoomWidth: eventDetails.floorPlanRoomWidth ?? '',
//             floorPlan: eventDetails.floorPlan ?? '',
//             floorPlanNotes: eventDetails.floorPlanNotes ?? '',
//             selectedGalleryImages: eventDetails.selectedGalleryImages ?? '[]',
//             otherEventOptions: eventDetails.otherEventOptions ?? '[]',
//             tableRequirements: eventDetails.tableRequirements ?? '[]',
//             utensilsAndEquipmentList: eventDetails.utensilsAndEquipmentList ?? '[]',
//             eventStaffList: eventDetails.eventStaffList ?? '[]'
//         });
//     }, [eventDetails]);

//     const inputHandle = (e) => {
//         setState(prev => ({ ...prev, [e.target.name]: e.target.value }));
//         setEventDetailsSaved(false);
//     };

//     const update_event_details_local = (e) => {
//         e.preventDefault();

//         // MultiSelectDropdown can trigger form submission; only proceed for the real save button
//         const submitter = e.nativeEvent.submitter;
//         if (submitter && submitter.name !== 'btnSaveEventDetails') {
//             return;
//         }

//         const updatedState = {
//             ...state,
//             eventName: toTitleCase(state.eventName),
//             venueName: toTitleCase(state.venueName),
//             selectedGalleryImages: JSON.stringify(selectedItemsSelectedGalleryImages),
//             otherEventOptions: JSON.stringify(selectedItemsOtherEventOptions),
//         };
//         setState(updatedState);

//         if (!userInfo) {
//             navigate('/login');
//             return;
//         }

//         dispatch(update_event_details_not_deposit({
//             customerId: userInfo.id,
//             eventName: updatedState.eventName,
//             selectedSellerPackage: updatedState.selectedSellerPackage,
//             venueName: updatedState.venueName,
//             venueAddress: updatedState.venueAddress,
//             eventType: updatedState.eventType,
//             eventDate: updatedState.eventDate,
//             eventStartTime: updatedState.eventStartTime,
//             eventServiceType: updatedState.eventServiceType,
//             eventPlaceSettings: updatedState.eventPlaceSettings,
//             eventGuestTableclothColor: updatedState.eventGuestTableclothColor,
//             eventBuffetTableclothColor: updatedState.eventBuffetTableclothColor,
//             eventNapkinColor: updatedState.eventNapkinColor,
//             venueManagerContactInfo: updatedState.venueManagerContactInfo,
//             venueDoorCode: updatedState.venueDoorCode,
//             eventGuestCount: updatedState.eventGuestCount,
//             selectedGalleryImages: updatedState.selectedGalleryImages,
//             eventNotes: updatedState.eventNotes,
//             otherEventOptions: updatedState.otherEventOptions,
//             tableRequirements: updatedState.tableRequirements,
//             utensilsAndEquipmentList: updatedState.utensilsAndEquipmentList,
//             eventStaffList: updatedState.eventStaffList
//         }));

//         const {
//             eventName, venueName, venueAddress, eventType, eventDate, eventStartTime,
//             eventServiceType, eventPlaceSettings, eventGuestTableclothColor, eventBuffetTableclothColor,
//             eventNapkinColor, venueManagerContactInfo, eventGuestCount
//         } = updatedState;

//         const baseValid = eventName && venueName && venueAddress && eventType && eventDate && eventStartTime;

//         if (!isDeposit) {
//             if (
//                 baseValid && eventServiceType && eventPlaceSettings && eventGuestTableclothColor &&
//                 eventBuffetTableclothColor && eventNapkinColor && venueManagerContactInfo && eventGuestCount
//             ) {
//                 setRes(true);
//             }
//         } else if (baseValid) {
//             setRes(true);
//         }
//     };

//     const place_order_local = () => {
//         if (!isDeposit && !sellerBoolShowSitePayments) {
//             dispatch(place_order({
//                 customerId: userInfo.id,
//                 customerName: userInfo.name,
//                 customerEmail: userInfo.email,
//                 customerPhone: userInfo.phoneNumber,
//                 orderType,
//                 price,
//                 products,
//                 eventDetailsInfo: state
//             }));
//         }

//         navigate('/payment', {
//             state: {
//                 price,
//                 products,
//                 eventDetailsInfo: state,
//                 isDeposit,
//                 items
//             }
//         });
//     };

//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, dispatch]);

//     return (
//         <div>
//             <Header />
//             <section>
//                 <ShopBanner
//                     homePage={'Home'} homeLink={'/'}
//                     currentPageTop={'Event Details'} currentPageTopLink={''}
//                     currentPageBottom1={'Event Details'} currentPageBottomLink1={''}
//                     currentPageBottom2={''} currentPageBottomLink2={''}
//                 />

//                 <div className='w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-0'>
//                     <div className='w-full flex flex-wrap pt-4'>
//                         <div className='w-[67%] md-lg:w-full'>
//                             <div className='flex flex-col gap-3'>
//                                 <div className='border p-4 shadow-sm'
//                                     style={{ color: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1, borderColor: sellerPrimaryColor1 }}>

//                                     <div className='border-none mb-3 grid grid-cols-3 xs:grid-cols-1 sm:grid-cols-1'
//                                         style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                         <div>
//                                             <span className='text-2xl font-bold flex'>
//                                                 <TbListDetails className='mr-1 mt-1' /> Event Details
//                                             </span>
//                                         </div>
//                                         <div>
//                                             <span className='text-xl font-semibold'>Please Fill In All Fields </span>
//                                             <span className='text-md' style={{ color: sellerRequiredFieldColor }}>(*&nbsp;Required)</span>
//                                         </div>
//                                         {sellerEnvironment === 'Dev' && (
//                                             <div className='text-[12px]'>
//                                                 <div>"_id": ObjectId("{eventDetails?._id}")</div>
//                                                 <div>depositGiven: {String(eventDetails?.depositGiven)}</div>
//                                                 <div>isDeposit: {String(isDeposit)}</div>
//                                                 <div>sellerBoolShowSitePayments: {String(sellerBoolShowSitePayments)}</div>
//                                             </div>
//                                         )}
//                                     </div>

//                                     {!res ? (
//                                         <form onSubmit={update_event_details_local}>
//                                             <div className={`${eventDetailsSaved ? 'bg-green-200 border-green-600' : 'bg-red-200 border-red-600'}
//                                                 flex pl-2 pr-2 h-[30px] w-[160px] items-center border rounded-lg`}>
//                                                 <button type="button" title="Save Layout" className="pr-0 flex text-green-600 rounded">
//                                                     <FiSave className='mr-1' size={20} />
//                                                     {eventDetailsSaved ? (
//                                                         <span className="text-[12px] text-green-600 font-bold">Event Details Saved</span>
//                                                     ) : (
//                                                         <span className="text-[12px] text-red-600 font-bold">Save Event Details</span>
//                                                     )}
//                                                 </button>
//                                             </div>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{ color: sellerPrimaryColor1 }}>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventName">
//                                                         Event Name <span style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <input required onChange={inputHandle} value={state.eventName} name="eventName" id="eventName" type="text"
//                                                         placeholder='Event Name e.g The Bar Mitzvah Of Ari Cohen'
//                                                         className='w-full px-3 py-1 border border-slate-200 rounded-md' />
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="selectedSellerPackage">Package</label>
//                                                     <select required onChange={inputHandle} value={state.selectedSellerPackage} name="selectedSellerPackage" id="selectedSellerPackage"
//                                                         className='w-full px-3 py-1 h-[33px] border border-slate-200 rounded-md'>
//                                                         <option value='None'>Choose Package</option>
//                                                         {sellerPackages.map((item, index) => (
//                                                             <option key={index} value={item.title}>{item.title}</option>
//                                                         ))}
//                                                     </select>
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="venueName">
//                                                         Venue Name <span style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <input required onChange={inputHandle} value={state.venueName} name="venueName" id="venueName" type="text"
//                                                         placeholder='Venue Name e.g Cong Adath Israel'
//                                                         className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                                                 </div>
//                                             </div>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{ color: sellerPrimaryColor1 }}>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="venueAddress">
//                                                         Venue Address <span style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <input required onChange={inputHandle} value={state.venueAddress} name="venueAddress" id="venueAddress" type="text"
//                                                         placeholder='Venue Full Address, City, State, Zipcode'
//                                                         className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="venueManagerContactInfo">
//                                                         Venue Manager <span className={isDeposit ? 'hidden' : ''} style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <input required={!isDeposit} onChange={inputHandle} value={state.venueManagerContactInfo} name="venueManagerContactInfo" id="venueManagerContactInfo"
//                                                         placeholder='Name/Phone Or N/A' type="text"
//                                                         className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="venueDoorCode">Venue Door Code</label>
//                                                     <input onChange={inputHandle} value={state.venueDoorCode} name="venueDoorCode" id="venueDoorCode"
//                                                         placeholder='Door Code' type="text"
//                                                         className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                                                 </div>
//                                             </div>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{ color: sellerPrimaryColor1 }}>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventType">
//                                                         Event Type <span style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <select required onChange={inputHandle} value={state.eventType} name="eventType" id="eventType"
//                                                         className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                         <option value="">Event Type</option>
//                                                         {[...sellerArrEventTypes].sort().map((p, i) => (
//                                                             <option key={i} value={p}>{p}</option>
//                                                         ))}
//                                                     </select>
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventDate">
//                                                         Date <span style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <input required onChange={inputHandle} value={state.eventDate} name="eventDate" id="eventDate"
//                                                         type="date" className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold flex' htmlFor="eventStartTime">
//                                                         Start Time <span style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <input required onChange={inputHandle} value={state.eventStartTime} type="time"
//                                                         name="eventStartTime" id="eventStartTime"
//                                                         className='w-full cursor-pointer px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                                                 </div>
//                                             </div>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{ color: sellerPrimaryColor1 }}>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventServiceType">
//                                                         Service Type <span className={isDeposit ? 'hidden' : ''} style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <select required={!isDeposit} onChange={inputHandle} value={state.eventServiceType} name="eventServiceType" id="eventServiceType"
//                                                         className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                         <option value="">Service Type</option>
//                                                         {sellerServiceTypes?.split(';').map((p, i) => (
//                                                             <option key={i} value={p}>{p}</option>
//                                                         ))}
//                                                     </select>
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventPlaceSettings">
//                                                         Place Settings <span className={isDeposit ? 'hidden' : ''} style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <select required={!isDeposit} onChange={inputHandle} value={state.eventPlaceSettings} name="eventPlaceSettings" id="eventPlaceSettings"
//                                                         className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                         <option value="">Place Settings</option>
//                                                         {sellerPlaceSettings?.split(';').map((p, i) => (
//                                                             <option key={i} value={p}>{p}</option>
//                                                         ))}
//                                                     </select>
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventGuestCount">
//                                                         Guest Count <span className={sellerMinGuestCount === '1' ? 'hidden' : ''}>(Min {sellerMinGuestCount})</span>
//                                                         <span className={isDeposit ? 'hidden' : ''} style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <input required={!isDeposit} min={!isDeposit ? sellerMinGuestCount : 0} onChange={inputHandle}
//                                                         value={state.eventGuestCount} type="number" name="eventGuestCount" id="eventGuestCount" placeholder='How Many People Are Coming?'
//                                                         className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                                                 </div>
//                                             </div>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{ color: sellerPrimaryColor1 }}>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventGuestTableclothColor">
//                                                         Guest Tablecloth Color <span className={isDeposit ? 'hidden' : ''} style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <select required={!isDeposit} onChange={inputHandle} value={state.eventGuestTableclothColor} name="eventGuestTableclothColor" id="eventGuestTableclothColor"
//                                                         className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                         <option value="">Guest Tablecloth Color</option>
//                                                         <option value="None">None</option>
//                                                         {sellerClothColors?.split(';').sort().map((p, i) => (
//                                                             <option key={i} value={p}>{p}</option>
//                                                         ))}
//                                                     </select>
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventBuffetTableclothColor">
//                                                         Buffet Tablecloth Color <span className={isDeposit ? 'hidden' : ''} style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <select required={!isDeposit} onChange={inputHandle} value={state.eventBuffetTableclothColor} name="eventBuffetTableclothColor" id="eventBuffetTableclothColor"
//                                                         className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                         <option value="">Buffet Tablecloth Color</option>
//                                                         <option value="None">None</option>
//                                                         {sellerClothColors?.split(';').sort().map((p, i) => (
//                                                             <option key={i} value={p}>{p}</option>
//                                                         ))}
//                                                     </select>
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventNapkinColor">
//                                                         Napkin Color <span className={isDeposit ? 'hidden' : ''} style={{ color: sellerRequiredFieldColor }}>*</span>
//                                                     </label>
//                                                     <select required={!isDeposit} onChange={inputHandle} value={state.eventNapkinColor} name="eventNapkinColor" id="eventNapkinColor"
//                                                         className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                         <option value="">Napkin Color</option>
//                                                         <option value="None">None</option>
//                                                         {sellerClothColors?.split(';').sort().map((p, i) => (
//                                                             <option key={i} value={p}>{p}</option>
//                                                         ))}
//                                                     </select>
//                                                 </div>
//                                             </div>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{ color: sellerPrimaryColor1 }}>
//                                                 {arrOtherEventOptionsChoicesNew.length > 0 && (
//                                                     <div className='gap-1 mb-2 w-full justify-start justify-items-start'>
//                                                         <span className='font-bold'>Other Event Options</span>
//                                                         <div className='w-[300px]'>
//                                                             <MultiSelectDropdown id="multiSelectedOtherEventOptions" items={arrOtherEventOptionsChoicesNew}
//                                                                 initialSelectedItems={selectedItemsOtherEventOptions}
//                                                                 onSelectionChange={setSelectedItemsOtherEventOptions} title="Select Other Event Options" />
//                                                             <SelectedItemsPanel
//                                                                 title="Selected Other Event Options:"
//                                                                 items={selectedItemsOtherEventOptions}
//                                                                 color={sellerPrimaryColor1}
//                                                                 emptyLabel="No other event options selected."
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                 )}
//                                                 {allSiteGalleryImagesNew.length > 0 && (
//                                                     <div className='gap-1 mb-2 w-full justify-start justify-items-start'>
//                                                         <Link to='/galleryImages' className='hover:underline'>
//                                                             <span className='font-bold'>Table Settings</span>
//                                                             <span className='font-italic text-md'> (Gallery Images)</span>
//                                                         </Link>
//                                                         <div className='w-[300px]'>
//                                                             <MultiSelectDropdown id="multiSelectedGalleryImages" items={allSiteGalleryImagesNew}
//                                                                 initialSelectedItems={selectedItemsSelectedGalleryImages}
//                                                                 onSelectionChange={setSelectedItemsSelectedGalleryImages} title="Select Table Settings" />
//                                                             <SelectedItemsPanel
//                                                                 title="Selected Table Settings:"
//                                                                 items={selectedItemsSelectedGalleryImages}
//                                                                 color={sellerPrimaryColor1}
//                                                                 emptyLabel="No Table Settings Selected."
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                 )}
//                                             </div>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{ color: sellerPrimaryColor1 }}>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventNotes">Event Notes</label>
//                                                     <textarea onChange={inputHandle} value={state.eventNotes} name="eventNotes" id="eventNotes"
//                                                         placeholder="Is There Anything Else We Need To Know? Are there any food related sensitivities or preferences you'd like us to know about?"
//                                                         className='w-full h-[120px] px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                                                 </div>
//                                             </div>

//                                             <div className='flex flex-col gap-1 mt-7 mb-2 w-full'>
//                                                 <button id="btnSaveEventDetails" name="btnSaveEventDetails" type="submit"
//                                                     className='cursor-pointer px-3 py-[6px] rounded-lg text-white' style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                                     Save Event Details
//                                                 </button>
//                                             </div>
//                                         </form>
//                                     ) : (
//                                         <div className='flex flex-col gap-1'>
//                                             <h2 className='text-slate-600 font-semibold pb-2'>
//                                                 {state.eventName} Event Details Summary
//                                             </h2>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-1 text-[14px]' style={{ color: sellerPrimaryColor1 }}>
//                                                 <SummaryItem label="Package" value={state.selectedSellerPackage} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Venue Name" value={state.venueName} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Venue Address" value={eventDetails?.venueAddress} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Deposit" value={eventDetails?.depositGiven ? 'Deposit Given' : 'Deposit Not Given'} color={sellerPrimaryColor1} />
//                                                 <SummaryItem
//                                                     label="Event Date/Time"
//                                                     value={Moment(`${eventDetails?.eventDate} ${eventDetails?.eventStartTime}`).format('dddd MM/DD/yyyy h:mm A')}
//                                                     color={sellerPrimaryColor1}
//                                                 />
//                                             </div>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-1 text-[14px]' style={{ color: sellerPrimaryColor1 }}>
//                                                 <SummaryItem label="Venue Door Code" value={eventDetails?.venueDoorCode} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Event Type" value={eventDetails?.eventType} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Service Type" value={eventDetails?.eventServiceType} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Place Settings" value={eventDetails?.eventPlaceSettings} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Guest Tablecloth Color" value={eventDetails?.eventGuestTableclothColor} color={sellerPrimaryColor1} />
//                                             </div>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-1 text-[14px]' style={{ color: sellerPrimaryColor1 }}>
//                                                 <SummaryItem label="Buffet Tablecloth Color" value={eventDetails?.eventBuffetTableclothColor} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Napkin Color" value={eventDetails?.eventNapkinColor} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Manager Contact" value={eventDetails?.venueManagerContactInfo} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Guest Count" value={eventDetails?.eventGuestCount} color={sellerPrimaryColor1} />
//                                                 <SummaryItem label="Notes" value={eventDetails?.eventNotes} color={sellerPrimaryColor1} />
//                                             </div>

//                                             <div className='grid 2xs:grid-cols-1 xs:grid-cols-1 sm:grid-cols-1
//                                                 md:grid-cols-1 md-lg:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 3xl:grid-cols-2
//                                                 4xl:grid-cols-2 4k:grid-cols-2 w-full gap-2' style={{ color: sellerPrimaryColor1 }}>
//                                                 <div className='p-1 border' style={{ borderColor: sellerPrimaryColor1 }}>
//                                                     <SelectedItemsPanel
//                                                         title="Selected Other Event Options:"
//                                                         items={selectedItemsOtherEventOptions}
//                                                         color={sellerPrimaryColor1}
//                                                         emptyLabel="No Other Event Options Selected."
//                                                     />
//                                                 </div>
//                                                 <div className='p-1 border' style={{ borderColor: sellerPrimaryColor1 }}>
//                                                     <SelectedItemsPanel
//                                                         title="Selected Table Settings:"
//                                                         items={selectedItemsSelectedGalleryImages}
//                                                         color={sellerPrimaryColor1}
//                                                         emptyLabel="No Table Settings Selected."
//                                                     />
//                                                 </div>
//                                             </div>

//                                             <div className='flex md:flex-col md:gap-2 w-full gap-1' style={{ color: sellerPrimaryColor1 }}>
//                                                 <div className='flex flex-col gap-1 mb-2 w-full border p-1'>
//                                                     <button onClick={() => setRes(false)}
//                                                         className='px-5 py-[6px] rounded-lg text-sm text-white uppercase'
//                                                         style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                                         Change Event Details
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>

//                         <div className='w-[33%] md-lg:w-full'>
//                             <div className='pl-3 md-lg:pl-0 md-lg:mt-5'>
//                                 <div className='border p-4 flex flex-col gap-3'
//                                     style={{ backgroundColor: sellerSecondaryColor1, borderColor: sellerPrimaryColor1, color: sellerPrimaryColor1 }}>
//                                     <div className='text-xl font-bold border-none border-slate-600 flex'>
//                                         {!isDeposit && (
//                                             <span className='flex'>
//                                                 <MdOutlineRestaurantMenu className='mr-1 mt-1' /> Items
//                                             </span>
//                                         )}
//                                         <span className='ml-1'>Summary</span>
//                                     </div>
//                                     <div className='flex justify-between items-center'>
//                                         {!isDeposit ? (
//                                             <span className='font-semibold'>{items} Items</span>
//                                         ) : (
//                                             <span className='font-semibold'>Deposit</span>
//                                         )}
//                                         {(isDeposit || sellerBoolShowSitePayments) && (
//                                             <span className='font-semibold'>{currencyFormat.format(price)}</span>
//                                         )}
//                                     </div>

//                                     {sellerBoolShowSitePayments && (
//                                         <div className='flex justify-between items-center'>
//                                             <span>Total</span>
//                                             <span className='text-lg'>{currencyFormat.format(price)}</span>
//                                         </div>
//                                     )}

//                                     {!sellerBoolShowSitePayments && (
//                                         <div>Once You Finalize Your Order, We Will Send You A Final Quote.</div>
//                                     )}
//                                     {!res && (
//                                         <div className='mt-2 font-semibold'>
//                                             If The Button Is Disabled, Please Complete The Event Details Section
//                                             And Click Save Event Details.
//                                         </div>
//                                     )}

//                                     <button onClick={place_order_local} disabled={!res}
//                                         className={`${res ? 'bg-green-700' : 'bg-gray-400'}
//                                         flex items-center justify-center w-full font-bold cursor-pointer px-5 py-[6px]
//                                         rounded-lg text-[15px] text-white uppercase`}>
//                                         <MdOutlineRestaurantMenu size={24} className='mr-1 mt-0' /> Finalize My Menu
//                                     </button>

//                                     {sellerEnvironment !== 'Prod' && (
//                                         <button onClick={place_order_local}
//                                             className='px-5 py-[6px] rounded-lg text-sm text-white uppercase'
//                                             style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                             Test Payment
//                                         </button>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//             <Footer />
//         </div>
//     );
// };

// export default EventDetails;






//my original code
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useLocation, useNavigate } from 'react-router-dom';

// import { FaCircleCheck } from "react-icons/fa6";
// import { FaCheck } from "react-icons/fa";
// import { CiCircleCheck } from "react-icons/ci";
// import { IoIosArrowForward } from "react-icons/io";
// import { FiSave } from 'react-icons/fi';
// import { TbListDetails } from "react-icons/tb";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { GiCheckMark } from "react-icons/gi";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";


// import { place_order } from '../store/reducers/orderReducer';
// import { update_event_details, update_event_details_not_deposit, get_event_details, 
//     messageClear } from '../store/reducers/eventDetailsReducer';
// import { get_sellerPackages_webSiteOrigin } from '../store/reducers/sellerPackageReducer';

// import { currencyFormat } from '../components/CurrencyFormat';
// import { toTitleCase } from '../components/toTitleCase';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import ShopBanner from '../components/ShopBanner';
// import GetSellerConfig from '../components/GetSellerConfig';
// import MultiSelectDropdown from '../components/MultiSelectDropdown';

// import Moment from 'moment';
// import toast from 'react-hot-toast';

// import config from '../config';
// import { all } from 'axios';

// const EventDetails = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const sellerArrEventTypes = config.STR_ARR_FRONTEND_EVENT_TYPES
//     const sellerBoolShowBrand = config.BOOL_SHOW_PRODUCT_BRAND
//     const sellerRequiredFieldColor = config.STR_FRONTEND_REQUIRED_FIELD_COLOR
//     const sellerEnvironment = config.STR_ENVIRONMENT

//     //const { seller } = useSelector(state => state.seller)
//     const { userInfo } = useSelector(state => state.auth) 
//     const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
//     const { sellerPackages, totalSellerPackage } = useSelector(state => state.sellerPackage)
//     const { allSiteGalleryImages } = useSelector(state => state.home)

//     const allSiteGalleryImagesNew = allSiteGalleryImages?.map(({ _id, caption, image }) => ({
//         id: _id,           // Keep existing key
//         name: caption,    // Create new key with different name   // Assign old value to new key
//         image: image      // Keep existing key
//     }));
//     //console.log('allSiteGalleryImages ', allSiteGalleryImages)
    
//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerShopName, 
//         sellerProductTerm, sellerProductPluralTerm, sellerClothColors, sellerMinGuestCount, sellerServiceTypes, 
//         sellerPlaceSettings, sellerOtherEventOptionsChoices, sellerBoolShowSitePayments, 
//     } = GetSellerConfig();

//     const [selectedItemsSelectedGalleryImages, setSelectedItemsSelectedGalleryImages] = useState([]); //SelectedGalleryImages
    
//     const arrOtherEventOptionsChoices = sellerOtherEventOptionsChoices ? sellerOtherEventOptionsChoices.split(';') : []
//     const arrOtherEventOptionsChoicesNew = arrOtherEventOptionsChoices.map((item, index) => ({
//         id: index,
//         name: item
//     }));
//     //console.log('arrOtherEventOptionsChoicesNew\n', arrOtherEventOptionsChoicesNew)
//     const [selectedItemsOtherEventOptions, setSelectedItemsOtherEventOptions] = useState([]); //OtherEventOptions: '[]'
//     const [eventDetailsSaved, setEventDetailsSaved] = useState(true);

//     //console.log('sellerBoolShowSitePayments ', sellerBoolShowSitePayments)
//     //console.log(seller)
//     // const {cart_products, cart_product_count, successMessage, price, buy_product_item, roduct

//     const { state: { products, price, shipping_fee, items }} = useLocation()
//     //console.log('products ', products)

//     //console.log('price ', price)
//     // const {cart_products, cart_product_count, successMessage, price, buy_product_item, 
//     // const {cart_products} = useSelector(state => state.cart)
//     //console.log('products ', products[0].products)

//     const productName = products[0].products[0].productInfo.name
//     //console.log(productName)
//     const isDeposit = productName === 'Deposit' ? 'true' : 'false'
//     const orderType = 'Menu Order'
//     //console.log(isDeposit)

//     //const eventDetailsHeader = productName === 'Deposit' ? 'eventName  venueName    venueAddress eventType    eventDate  eventStartTime' : ''
//     //eventName &&    venueName &&    venueAddress && eventType &&    eventDate  && eventStartTime
//     //console.log('cart_products ', cart_products)

//     const dispatch = useDispatch()
//     const navigate = useNavigate()
//     const [res, setRes] = useState(false)

//     useEffect(() => {
//         dispatch(get_event_details(userInfo.id))
//     },[userInfo.id])
    
//     useEffect(() => {
//         dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL))
//         //console.log('dispatch get_banners ', banners)
//     },[])

//     useEffect(() => {
//         if (eventDetails) {
//             setSelectedItemsSelectedGalleryImages(JSON.parse(eventDetails?.selectedGalleryImages))
//             setSelectedItemsOtherEventOptions(JSON.parse(eventDetails?.otherEventOptions))
//         }
//     },[eventDetails])    
    
//     const [state, setState] = useState({
//         depositGiven: isDeposit, eventName: '', selectedSellerPackage: 'None', venueName: '', venueAddress: '', 
//         eventType: '', eventDate: '', eventStartTime: '', eventServiceType: '', eventPlaceSettings: '', eventGuestTableclothColor:'', eventBuffetTableclothColor: '',
//         eventNapkinColor: '', venueManagerContactInfo: '', venueDoorCode: '', eventGuestCount: '', eventNotes: '', floorPlanCanvasHeight: '',
//         floorPlanCanvasWidth: '', floorPlanRoomHeight: '', floorPlanRoomWidth: '', floorPlan: '', floorPlanNotes: '', 
//         selectedGalleryImages: '[]', otherEventOptions: '[]', tableRequirements: '[]', utensilsAndEquipmentList: '[]', eventStaffList: '[]'
//     })
//     //console.log(state)
    
//     const inputHandle = (e) => {
//         setState({
//             ...state,
//             [e.target.name]: e.target.value
//         })
//         setEventDetailsSaved(false);
//         //save look at floor planner
//         //console.log(state)
//         //console.log(e.target.value)
//     }

//     const close_set_time  = (e) => {
//         e.preventDefault()
//     }

//     const [showTimePickerPopup, setShowTimePickerPopup] = useState(false);

//     const closeTimePickerPopup = () => {
//         setShowTimePickerPopup(false);
//     };

//     const openTimePickerPopup = () => {
//         setShowTimePickerPopup(true);
//     };
    
//     useEffect(() => {
//         setState({
//             depositGiven: eventDetails?.depositGiven,
//             eventName: eventDetails?.eventName, 
//             selectedSellerPackage: eventDetails?.selectedSellerPackage,
//             venueName: eventDetails?.venueName, 
//             venueAddress: eventDetails?.venueAddress,
//             eventType: eventDetails?.eventType, 
//             eventDate: eventDetails?.eventDate, 
//             eventStartTime: eventDetails?.eventStartTime,
//             eventServiceType: eventDetails?.eventServiceType, 
//             eventPlaceSettings: eventDetails?.eventPlaceSettings, 
//             eventGuestTableclothColor: eventDetails?.eventGuestTableclothColor, 
//             eventBuffetTableclothColor: eventDetails?.eventBuffetTableclothColor,
//             eventNapkinColor: eventDetails?.eventNapkinColor,
//             venueManagerContactInfo: eventDetails?.venueManagerContactInfo,
//             venueDoorCode: eventDetails?.venueDoorCode,
//             eventGuestCount: eventDetails?.eventGuestCount, 
//             eventNotes: eventDetails?.eventNotes,
//             floorPlanCanvasHeight: eventDetails?.floorPlanCanvasHeight,
//             floorPlanCanvasWidth: eventDetails?.floorPlanCanvasWidth,
//             floorPlanRoomHeight: eventDetails?.floorPlanRoomHeight,
//             floorPlanRoomWidth: eventDetails?.floorPlanRoomWidth,
//             floorPlan: eventDetails?.floorPlan,
//             floorPlanNotes: eventDetails?.floorPlanNotes,
//             selectedGalleryImages: eventDetails?.selectedGalleryImages,
//             otherEventOptions: eventDetails?.otherEventOptions,
//             tableRequirements: eventDetails?.tableRequirements,
//             utensilsAndEquipmentList: eventDetails?.utensilsAndEquipmentList ?? '[]',
//             eventStaffList: eventDetails?.eventStaffList ?? '[]'
//         })
//         //dispatch(messageClear())
//     }, [eventDetails])
//     //console.log('eventDetails ', eventDetails)
//     //console.log('state payment page ', state)// floorPlan,
        
//     const update_event_details_local = (e) => {
//         //console.log('update_event_details_local ',  e.target.name)
//         e.preventDefault()
//         //MultiSelectDropdown was causing form submission
//         const submitter = e.nativeEvent.submitter;
//         //console.log('submitter ', submitter.id, submitter.name) //btnSaveEventDetails
//         if (submitter && submitter.name !== 'btnSaveEventDetails') {
//             return;
//         }

//         let {eventName, selectedSellerPackage,  venueName,      venueAddress,   eventType,      eventDate,  eventStartTime, 
//             eventServiceType, eventPlaceSettings, eventGuestTableclothColor, eventBuffetTableclothColor, eventNapkinColor,
//             venueManagerContactInfo, venueDoorCode, eventGuestCount, eventNotes, selectedGalleryImages, otherEventOptions, 
//             tableRequirements, utensilsAndEquipmentList, eventStaffList } = state;

//         state.eventName = toTitleCase(state.eventName)
//         state.venueName = toTitleCase(state.venueName)
//         // console.log('selectedItems submit ', selectedItemsSelectedGalleryImages)
//         state.selectedGalleryImages = JSON.stringify(selectedItemsSelectedGalleryImages)
//         state.otherEventOptions = JSON.stringify(selectedItemsOtherEventOptions)
//         // console.log('state ', state)
//         if (userInfo) {
//             //console.log('depositGiven ', eventDetails?.depositGiven.toString())
//             //const isDeposit = productName === 'Deposit' ? 'true' : 'false'
//             dispatch(update_event_details_not_deposit({
//                 customerId: userInfo.id,
//                 // depositGiven: state.depositGiven,  //dont change it  false, // set to false here, set to true after cusotmer pays  isDeposit, //false,
//                 // what if customer alreay gave deposit and now he is completeing his order
//                 // orderType?
//                 eventName: state.eventName, 
//                 selectedSellerPackage: state.selectedSellerPackage,
//                 venueName: state.venueName, 
//                 venueAddress: state.venueAddress,
//                 eventType: state.eventType, 
//                 eventDate: state.eventDate, 
//                 eventStartTime: state.eventStartTime,
//                 eventServiceType: state.eventServiceType, 
//                 eventPlaceSettings: state.eventPlaceSettings, 
//                 eventGuestTableclothColor: state.eventGuestTableclothColor, 
//                 eventBuffetTableclothColor: state.eventBuffetTableclothColor,
//                 eventNapkinColor: state.eventNapkinColor,
//                 venueManagerContactInfo: state.venueManagerContactInfo, 
//                 venueDoorCode: state.venueDoorCode,
//                 eventGuestCount: state.eventGuestCount, 
//                 selectedGalleryImages: state.selectedGalleryImages,
//                 eventNotes: state.eventNotes,
//                 otherEventOptions: state.otherEventOptions,
//                 tableRequirements: state.tableRequirements,
//                 utensilsAndEquipmentList: state.utensilsAndEquipmentList,
//                 eventStaffList: state.eventStaffList
//             }))
//         } else {
//             navigate('/login')
//         }
        
//         if (isDeposit === 'false') {
//             if (eventName &&    venueName &&    venueAddress && eventType &&    eventDate && eventStartTime 
//                 && eventServiceType && eventPlaceSettings && eventGuestTableclothColor && eventBuffetTableclothColor && eventNapkinColor
//                 && venueManagerContactInfo && eventGuestCount) 
//                 {
//                     setRes(true) //state.myOrder // && eventNotes
//                 }
//         } else if(isDeposit === 'true') {
//             if (eventName &&    venueName &&    venueAddress && eventType &&    eventDate  && eventStartTime) 
//                 {
//                     setRes(true) //state.myOrder // && eventNotes
//                 }
//         }
//     }

//     const place_order_local = () => {
//         // console.log(products)
//         // console.log(state)
//         // backend const {
//         // customerId, customerName, customerEmail, customerPhone, 
//         // price, products, eventDetailsInfo} = req.body
//         // if no payemnt then place order
//         // not depsite and payment off
//         // console.log('place_order_local isDeposit', isDeposit, '\nsellerBoolShowSitePayments', sellerBoolShowSitePayments)
//         // console.log('place_order price ', state)
            
//         if (isDeposit === 'false' && sellerBoolShowSitePayments === false) {
//             //console.log('place_order orderType ', orderType)
//             //console.log('place_order price ', state)
//             dispatch(place_order({
//                 customerId: userInfo.id, customerName: userInfo.name, customerEmail:userInfo.email, customerPhone: userInfo.phoneNumber,
//                 orderType, price, products, eventDetailsInfo : state 
//             }))
//         }
//         //console.log('navigate to payment page eventDetailsInfo\n', state)
        
//         navigate('/payment',{
//             state: {
//                 price: price, 
//                 products: products,
//                 eventDetailsInfo : state,
//                 isDeposit: isDeposit,
//                 items: items
//             }
//         })           
//     }
    
//     useEffect(() => { 
//         if (successMessage) {
//             //console.log(successMessage)
//             toast.success(successMessage)
//             dispatch(messageClear())  
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     return (
//         <div>
//             <Header/>
//             <section className=''>
//                 {/*   */}
//                 <div className=''>
//                     <ShopBanner homePage={'Home'} homeLink={'/'} currentPageTop={'Event Details'} currentPageTopLink={''} 
//                         currentPageBottom1={'Event Details'} currentPageBottomLink1={''}
//                         currentPageBottom2={''} currentPageBottomLink2={''} />
//                 </div>       
                
//                 <div className='w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-0'>
//                     <div className='w-full flex flex-wrap pt-4'>
//                         <div className='w-[67%] md-lg:w-full'>
//                             <div className='flex flex-col gap-3'>
//                                 <div className='border p-4 shadow-sm' 
//                                     style={{color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}>
                                    
//                                     <div className='border-none mb-3 grid grid-cols-3 xs:grid-cols-1 sm:grid-cols-1' 
//                                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div>
//                                             <span className='text-2xl font-bold flex'>
//                                                 <TbListDetails className='mr-1 mt-1' /> Event Details
//                                             </span> 
//                                         </div>
//                                         <div>
//                                             <span className='text-xl font-semibold'>Please Fill In All Fields </span>
//                                             <span className='text-md' style={{color:sellerRequiredFieldColor}}>(*&nbsp;Required)</span>
//                                         </div>
//                                         <div className=''>
//                                             <div className={` ${sellerEnvironment === 'Dev' ? '' : 'hidden'} text-[12px]`}>
//                                                 <div>eventDetails?._id</div>
//                                                 <div>"_id": ObjectId("{eventDetails?._id}")</div>
//                                                 <div>depositGiven: {eventDetails?.depositGiven?.toString()}</div>
//                                                 <div>isDeposit: {isDeposit.toString()}</div>
//                                                 <div>sellerBoolShowSitePayments: {sellerBoolShowSitePayments.toString()}</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     {
//                                         //show form
//                                         !res && <>
//                                             <form onSubmit={update_event_details_local}>
//                                                 <div className={`${eventDetailsSaved ? 'bg-green-200 border-green-600' : 'bg-red-200 border-red-600'} 
//                                                     flex pl-2 pr-2 h-[30px] w-[160px] items-center border rounded-lg`}>
//                                                     <button title="Save Layout" className="pr-0 flex text-green-600 rounded">
//                                                         <FiSave className='mr-1' size={20} />
//                                                         <div className="flex ">
//                                                             <span className={`${eventDetailsSaved ? 'hidden' : ''} text-[12px] text-red-600 font-bold`}>
//                                                                 Save Event Details
//                                                             </span>
//                                                             <span className={`${eventDetailsSaved ? '' : 'hidden'} text-[12px] text-green-600 font-bold`}>
//                                                                 Event Details Saved
//                                                             </span>
//                                                         </div>
//                                                     </button>
//                                                 </div>
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="eventName">
//                                                             Event Name <span style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <input required onChange={inputHandle} value={state.eventName} name="eventName" id="eventName" type="text" 
//                                                             placeholder='Event Name e.g The Bar Mitzvah Of Ari Cohen' 
//                                                             className='w-full px-3 py-1 border border-slate-200 rounded-md' /> 
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="selectedSellerPackage">Package</label>
//                                                         <select required onChange={inputHandle} value={state.selectedSellerPackage} name="selectedSellerPackage" id="selectedSellerPackage" 
//                                                             className='w-full px-3 py-1 h-[33px] border border-slate-200 rounded-md'>
//                                                             <option value='None'>Choose Package</option>
//                                                             {
//                                                                 sellerPackages.map((item, index) => 
//                                                                     <option key={index} value={item.title}>{item.title}</option>
//                                                                 )
//                                                             }
//                                                         </select>
//                                                     </div>
//                                                     {
//                                                         //selectedSellerPackage
//                                                     }
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="venueName">
//                                                             Venue Name <span style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <input required onChange={inputHandle} value={state.venueName} name="venueName" id="venueName" type="text" 
//                                                             placeholder='Venue Name e.g Cong Adath Israel' 
//                                                             className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' /> 
//                                                     </div>
//                                                 </div>
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="venueAddress">
//                                                             Venue Address <span style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <input required onChange={inputHandle} value={state.venueAddress} name="venueAddress" id="venueAddress"  type="text" 
//                                                             placeholder='Venue Full Address, City, State, Zipcode' 
//                                                             className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' /> 
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="venueManagerContactInfo">
//                                                             Venue Manager <span className={`${isDeposit === 'true' ? 'hidden' : ''} `} style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <input required={isDeposit === 'false'} onChange={inputHandle} value={state.venueManagerContactInfo} name="venueManagerContactInfo" id="venueManagerContactInfo" 
//                                                             placeholder='Name/Phone Or N/A' type="text"
//                                                             className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' /> 
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="venueDoorCode">Venue Door Code</label>
//                                                         <input onChange={inputHandle} value={state.venueDoorCode} name="venueDoorCode" id="venueDoorCode" 
//                                                             placeholder='Door Code' type="text"
//                                                             className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                                                     </div>
//                                                 </div>  
//                                                 {
//                                                     //<DatePicker selected={startDate} onChange={(date) => setStartDate(date)}  
//                                                     //name="eventDate" id="eventDate" />
//                                                     //{(date) => setStartDate(date)}
//                                                     //import { FaCalendar } from "react-icons/fa";
//                                                     //import FloorPlanner from './../components/customerDashboard/FloorPlannerWithSnapToGrid';

//                                                     //https://www.npmjs.com/package/react-datepicker

//                                                     //<input aria-label="Time" type="time" />

//                                                     //<input aria-label="Date" type="date" />
//                                                 }
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="eventType">
//                                                             Event Type <span style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <select required onChange={inputHandle} value={state.eventType} name="eventType" id="eventType" 
//                                                             className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                             <option value="">Event Type</option>
//                                                             {
//                                                                 sellerArrEventTypes.sort().map((p, i) =>
//                                                                     <option key={i} value={p}>{p}</option>
//                                                                 )
//                                                                 // onChange={(e) => setCategory(e.target.value) 
//                                                             }
//                                                         </select>
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="eventDate">
//                                                             Date <span style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <input required onChange={inputHandle} value={state.eventDate} name="eventDate" id="eventDate" 
//                                                             type="date" className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' /> 
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold flex' htmlFor="eventStartTime">
//                                                             Start Time <span style={{color:sellerRequiredFieldColor}}>*</span>
//                                                             <div className='hidden'>
//                                                                 <button onClick={close_set_time} 
//                                                                     className='ml-2 px-2 py-[2px] text-[12px] flex rounded-md text-white' 
//                                                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                                                     <FaCircleCheck className='mr-1 mt-1' /> Done
//                                                                 </button>
//                                                             </div>
//                                                         </label>

//                                                         <div className="relative">
//                                                             {/* Time input */}
//                                                             <input required
//                                                                 onChange={inputHandle} 
//                                                                 value={state.eventStartTime} 
//                                                                 type="time" 
//                                                                 name="eventStartTime" 
//                                                                 id="eventStartTime"  
//                                                                 onClick={() => setShowTimePickerPopup(true)}
//                                                                 className='w-full cursor-pointer px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' 
//                                                             />

//                                                             {/* Popup */}
//                                                             {showTimePickerPopup && (
//                                                                 <div className="absolute cursor-pointer z-10 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg p-3">
                                                                    
//                                                                     {/* Close button inside popup */}
//                                                                     <div className="flex justify-end">
//                                                                         <button
//                                                                         type="button"
//                                                                         onClick={closeTimePickerPopup}
//                                                                         className="text-red-400 hover:text-red-600 font-bold"
//                                                                         >
//                                                                         Close
//                                                                         </button>
//                                                                     </div>
//                                                                     {/* Your popup content here */}
//                                                                 </div>
//                                                             )}
//                                                         </div>

//                                                         {
//                                                         // <input required onChange={inputHandle} value={state.eventStartTime} name="eventStartTime" id="eventStartTime" 
//                                                         //     type="time" className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' /> 
//                                                         }
                                                        
                                                    
//                                                     </div>
//                                                 </div>
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="eventServiceType">
//                                                             Service Type <span className={`${isDeposit === 'true' ? 'hidden' : ''} `} style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <select required={isDeposit === 'false'} onChange={inputHandle} value={state.eventServiceType} name="eventServiceType" id="eventServiceType" 
//                                                             className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                             <option value="">Service Type</option>
//                                                             {

//                                                                 sellerServiceTypes !== undefined &&
//                                                                     sellerServiceTypes.split(';').map((p, i) =>
//                                                                         <option key={i} value={p}>{p}</option>
//                                                                     )
//                                                             }
//                                                         </select>
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="eventPlaceSettings">
//                                                             Place Settings <span className={`${isDeposit === 'true' ? 'hidden' : ''} `} style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <select required={isDeposit === 'false'} onChange={inputHandle} value={state.eventPlaceSettings} name="eventPlaceSettings" id="eventPlaceSettings" 
//                                                             className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                             <option value="">Place Settings</option>
//                                                             {
//                                                                  sellerPlaceSettings !== undefined &&
//                                                                     sellerPlaceSettings.split(';').map((p, i) =>
//                                                                         <option key={i} value={p}>{p}</option>
//                                                                     )
//                                                             }
//                                                         </select>
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold'  htmlFor="eventGuestCount">
//                                                             Guest Count <span className={`${sellerMinGuestCount === '1' ? 'hidden' : ''}`}>(Min {sellerMinGuestCount})</span>
//                                                             <span className={`${isDeposit === 'true' ? 'hidden' : ''} `} style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <input required={isDeposit === 'false'} min={isDeposit === 'false' ? sellerMinGuestCount : 0} onChange={inputHandle} 
//                                                             value={state.eventGuestCount} type="number"  name="eventGuestCount" id="eventGuestCount" placeholder='How Many People Are Coming?'
//                                                             className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' /> 
//                                                     </div>
//                                                 </div>
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="eventGuestTableclothColor">
//                                                             Guest Tablecloth Color <span className={`${isDeposit === 'true' ? 'hidden' : ''} `} style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <select required={isDeposit === 'false'} onChange={inputHandle} value={state.eventGuestTableclothColor} name="eventGuestTableclothColor" id="eventGuestTableclothColor" 
//                                                             className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                             <option value="">Guest Tablecloth Color</option>
//                                                             <option value="None">None</option>
//                                                             {
//                                                                 sellerClothColors !== undefined &&
//                                                                     sellerClothColors.split(';').sort().map((p, i) =>
//                                                                         <option key={i} value={p}>{p}</option>
//                                                                     ) 
//                                                             }
//                                                         </select>
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="eventBuffetTableclothColor">
//                                                             Buffet Tablecloth Color <span className={`${isDeposit === 'true' ? 'hidden' : ''} `} style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <select required={isDeposit === 'false'} onChange={inputHandle} value={state.eventBuffetTableclothColor} name="eventBuffetTableclothColor" id="eventBuffetTableclothColor" 
//                                                             className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                             <option value="">Buffet Tablecloth Color</option>
//                                                             <option value="None">None</option>
//                                                             {
//                                                                 sellerClothColors !== undefined &&
//                                                                     sellerClothColors.split(';').sort().map((p, i) =>
//                                                                         <option key={i} value={p}>{p}</option>
//                                                                     )
//                                                             }
//                                                         </select>
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                         <label className='font-bold' htmlFor="eventNapkinColor">
//                                                             Napkin Color <span className={`${isDeposit === 'true' ? 'hidden' : ''} `} style={{color:sellerRequiredFieldColor}}>*</span>
//                                                         </label>
//                                                         <select required={isDeposit === 'false'} onChange={inputHandle} value={state.eventNapkinColor} name="eventNapkinColor" id="eventNapkinColor" 
//                                                             className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                                             <option value="">Napkin Color</option>
//                                                             <option value="None">None</option>
//                                                             {
//                                                                 sellerClothColors !== undefined &&
//                                                                     sellerClothColors.split(';').sort().map((p, i) =>
//                                                                         <option key={i} value={p}>{p}</option>
//                                                                     )
//                                                             }
//                                                         </select>
//                                                     </div>
//                                                 </div>
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                                                     <div className={` ${arrOtherEventOptionsChoicesNew.length > 0 ? '' : 'hidden'} 
//                                                         gap-1 mb-2 w-full justify-start justify-items-start `}>
//                                                         <span className='font-bold'>Other Event Options</span>
//                                                         <div className='w-[300px]'>
//                                                             <MultiSelectDropdown id="multiSelectedOtherEventOptions" items={arrOtherEventOptionsChoicesNew} 
//                                                                 initialSelectedItems={selectedItemsOtherEventOptions} 
//                                                                 onSelectionChange={setSelectedItemsOtherEventOptions} title="Select Other Event Options" />
//                                                             <div className="p-2 bg-gray-50 border border-gray-200 rounded-md h-[80px] overflow-y-auto" 
//                                                                 style={{color:sellerPrimaryColor1}}>
//                                                                 <div className="text-[14px] font-semibold mb-0">
//                                                                     Selected Other Event Options:
//                                                                 </div> 
//                                                                 {selectedItemsOtherEventOptions.length > 0 ? (
//                                                                     <ul className=" space-y-1">
//                                                                         {selectedItemsOtherEventOptions.map((item) => (
//                                                                             <li key={item.id} className="flex items-center justify-between w-full 
//                                                                                 px-1 py-0 text-left border-none" style={{borderColor:sellerPrimaryColor1}}>
//                                                                                 <span className="font-normal text-[14px]" style={{color:sellerPrimaryColor1}}>
//                                                                                     {item.name}
//                                                                                 </span>
//                                                                                 <GiCheckMark className="w-5 h-5 text-green-500 inline-block" /> 
//                                                                             </li>
//                                                                         ))}
//                                                                     </ul>
//                                                                     ) : (
//                                                                     <p className="italic font-normal text-[13px]">No other event options selected.</p>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className={` ${allSiteGalleryImagesNew.length > 0 ? '' : 'hidden'} 
//                                                         gap-1 mb-2 w-full justify-start justify-items-start `}>
//                                                         <Link to='/galleryImages' className='hover:underline'>
//                                                             <span className='font-bold'>Table Settings</span>
//                                                             <span className='font-italic text-md'> (Gallery Images)</span>
//                                                         </Link>
//                                                         <div className='w-[300px]'>
//                                                             <MultiSelectDropdown id="multiSelectedGalleryImages" items={allSiteGalleryImagesNew} 
//                                                                 initialSelectedItems={selectedItemsSelectedGalleryImages} 
//                                                                 onSelectionChange={setSelectedItemsSelectedGalleryImages} title="Select Table Settings" />
//                                                             <div className="p-2 bg-gray-50 border border-gray-200 rounded-md h-[80px] overflow-y-auto" 
//                                                                 style={{color:sellerPrimaryColor1}}>
//                                                                 <div className="text-[14px] font-semibold mb-0">
//                                                                     Selected Table Settings:
//                                                                 </div>  
//                                                                 {selectedItemsSelectedGalleryImages.length > 0 ? (
//                                                                     <ul className=" space-y-1">
//                                                                         {selectedItemsSelectedGalleryImages.map((item) => (
//                                                                             <li key={item.id} className="flex items-center justify-between w-full 
//                                                                                 px-1 py-0 text-left border-none" style={{borderColor:sellerPrimaryColor1}}>
//                                                                                 <span className="font-normal text-[14px]" style={{color:sellerPrimaryColor1}}>
//                                                                                     {item.name}
//                                                                                 </span>
//                                                                                 <GiCheckMark className="w-5 h-5 text-green-500 inline-block" /> 
//                                                                             </li>
//                                                                         ))}
//                                                                     </ul>
//                                                                     ) : (
//                                                                     <p className="italic font-normal text-[13px]">No Table Settings Selected.</p>
//                                                                 )}
//                                                             </div>
//                                                         </div>    
//                                                     </div>
//                                                 </div>
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full'>
//                                                     <label className='font-bold' htmlFor="eventNotes">Event Notes</label>
//                                                         <textarea onChange={inputHandle} value={state.eventNotes} name="eventNotes" id="eventNotes" type="text"  
//                                                             placeholder="Is There Anything Else We Need To Know? Are there any food related sensitivities or preferences you'd like us to know about?"
//                                                             className='w-full h-[120px] px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md'  />
//                                                     </div>
//                                                 </div>
//                                                 <div className='flex flex-col gap-1 mt-7 mb-2 w-full'>
//                                                     <button id="btnSaveEventDetails" name="btnSaveEventDetails" type="submit"
//                                                         className='cursor-pointer px-3 py-[6px] rounded-lg text-white' style={{backgroundColor:sellerPrimaryColor1}}>
//                                                         Save Event Details
//                                                     </button>
//                                                 </div> 
//                                             </form>
//                                         </>
//                                     }
//                                     {
//                                         res && 
//                                         <div className='flex flex-col gap-1'>
//                                             <h2 className='text-slate-600 font-semibold pb-2'>
//                                                 {state.eventName} Event Details Summary 
//                                             </h2>
//                                             <p>
//                                                 <span className=' hidden bg-blue-200 text-blue-800 text-sm font-medium mr-2 px-2 py-1 rounded'>Home</span>
                                                
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-1 text-[14px]' 
//                                                     style={{color:sellerPrimaryColor1}}>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Package</span> 
//                                                         {state.selectedSellerPackage}
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Venue Name</span> 
//                                                         {state.venueName}
//                                                     </div>
//                                                     {
//                                                         //selectedSellerPackage
//                                                     }
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Venue Address</span>
//                                                         {eventDetails?.venueAddress}
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Deposit</span>
//                                                         {
//                                                             eventDetails?.depositGiven ? 'Deposit Given' : 'Deposit Not Given'
//                                                         }
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Event Date/Time</span>
//                                                         {Moment(eventDetails?.eventDate + ' ' + eventDetails?.eventStartTime).format('dddd MM/DD/yyyy h:mm A')}
//                                                     </div>
//                                                 </div>
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-1 text-[14px]' style={{color:sellerPrimaryColor1}}>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Venue Door Code</span>
//                                                         {eventDetails?.venueDoorCode}
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Event Type</span>
//                                                         {eventDetails?.eventType}
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Service Type</span>
//                                                         {eventDetails?.eventServiceType}
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Place Settings</span>
//                                                         {eventDetails?.eventPlaceSettings}
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Guest Tablecloth Color</span>
//                                                         {eventDetails?.eventGuestTableclothColor}
//                                                     </div>
//                                                 </div>
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-1 text-[14px]' style={{color:sellerPrimaryColor1}}>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Buffet Tablecloth Color</span>
//                                                         {eventDetails?.eventBuffetTableclothColor}
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Napkin Color</span>
//                                                         {eventDetails?.eventNapkinColor}
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Manager Contact</span>
//                                                         {eventDetails?.venueManagerContactInfo}
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Guest Count</span>
//                                                         {eventDetails?.eventGuestCount}
//                                                     </div>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'
//                                                         style={{borderColor:sellerPrimaryColor1}}>
//                                                         <span className='font-semibold'>Notes</span>
//                                                         {eventDetails?.eventNotes}
//                                                     </div>
//                                                 </div>
                                                
//                                                 <div className='grid 2xs:grid-cols-1 xs:grid-cols-1 sm:grid-cols-1 
//                                                     md:grid-cols-1 md-lg:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 3xl:grid-cols-2 
//                                                     4xl:grid-cols-2 4k:grid-cols-2
//                                                     w-full gap-2' 
//                                                     style={{color:sellerPrimaryColor1}}>
//                                                     <div className='p-1 border' style={{borderColor:sellerPrimaryColor1}}>
//                                                         <div className='p-2 bg-gray-50 border border-gray-200 rounded-md h-[80px] overflow-y-auto'
//                                                             style={{color:sellerPrimaryColor1}}>
//                                                             <div className="text-[14px] font-semibold mb-0">
//                                                                 Selected Other Event Options:
//                                                             </div>  
//                                                             {selectedItemsOtherEventOptions.length > 0 ? (
//                                                                 <ul className=" space-y-1">
//                                                                     {selectedItemsOtherEventOptions.map((item) => (
//                                                                         <li key={item.id} className="flex items-center justify-between w-full 
//                                                                             px-1 py-0 text-left border-none" style={{borderColor:sellerPrimaryColor1}}>
//                                                                             <span className="font-normal text-[14px]" style={{color:sellerPrimaryColor1}}>
//                                                                                 {item.name}
//                                                                             </span>
//                                                                             <GiCheckMark className="w-5 h-5 text-green-500 inline-block" /> 
//                                                                         </li>
//                                                                     ))}
//                                                                 </ul>
//                                                                 ) : (
//                                                                 <p className="italic font-normal text-[13px]">No Table Settings Selected.</p>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                     <div className='p-1 border' style={{borderColor:sellerPrimaryColor1}}>
//                                                         <div className="p-2 bg-gray-50 border border-gray-200 rounded-md h-[80px] overflow-y-auto" 
//                                                             style={{color:sellerPrimaryColor1}}>
//                                                             <div className="text-[14px] font-semibold mb-0">
//                                                                 Selected Table Settings:
//                                                             </div>  
//                                                             {selectedItemsSelectedGalleryImages.length > 0 ? (
//                                                                 <ul className=" space-y-1">
//                                                                     {selectedItemsSelectedGalleryImages.map((item) => (
//                                                                         <li key={item.id} className="flex items-center justify-between w-full 
//                                                                             px-1 py-0 text-left border-none" style={{borderColor:sellerPrimaryColor1}}>
//                                                                             <span className="font-normal text-[14px]" style={{color:sellerPrimaryColor1}}>
//                                                                                 {item.name}
//                                                                             </span>
//                                                                             <GiCheckMark className="w-5 h-5 text-green-500 inline-block" /> 
//                                                                         </li>
//                                                                     ))}
//                                                                 </ul>
//                                                                 ) : (
//                                                                 <p className="italic font-normal text-[13px]">No Table Settings Selected.</p>
//                                                             )}
//                                                         </div>
//                                                     </div>

//                                                 </div>
//                                                 <div className='flex md:flex-col md:gap-2 w-full gap-1' style={{color:sellerPrimaryColor1}}>
//                                                     <div className='flex flex-col gap-1 mb-2 w-full border p-1'>
//                                                     <button onClick={() => setRes(false)} 
//                                                         className='px-5 py-[6px] rounded-lg text-sm text-white uppercase' 
//                                                         style={{backgroundColor:sellerPrimaryColor1}}>Change Event Details</button>
//                                                     </div>
//                                                 </div>
//                                                 <span onClick={() => setRes(false)} className='hidden text-indigo-500 cursor-pointer'>
//                                                     Change
//                                                 </span>
//                                             </p>
//                                             <p className='hidden text-slate-600 text-sm' >Email To {userInfo?.email}</p>
//                                         </div>
//                                     }
//                                 </div>
//                                 {
//                                     products.map((p,i) => 
//                                         <div key={i} className='hidden'>
//                                             <div className='flex border p-4 flex-col gap-2' 
//                                                 style={{backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                 <div className='flex justify-start items-center'>
//                                                     <h2 className='text-xl font-bold' style={{color:sellerPrimaryColor1}}>
//                                                         {sellerShopName} 
//                                                     </h2>
//                                                 </div>
//                                                 {
//                                                     p.products.map((pt,i) => 
//                                                         <div key={i} className=' w-full border p-2 flex flex-wrap'>
//                                                             <div className='flex sm:w-full gap-2 w-7/12'>
//                                                                 <div className='flex gap-2 justify-start items-center'>
//                                                                     <div className={` ${pt.productInfo.name === 'Deposit' ? 'hidden' : ''} `} >
//                                                                         <img className='w-[80px] h-[80px]' src={pt.productInfo.images[0]} alt="" />
//                                                                     </div>
//                                                                     <div className='pr-4' style={{color:sellerPrimaryColor1}}>
//                                                                         <h2 className='text-md font-semibold'>
//                                                                             {pt.productInfo.name} 
//                                                                         </h2>
//                                                                         <span className={` ${sellerBoolShowBrand ? 'text-sm' : 'hidden' } `}>
//                                                                             Brand: {pt.productInfo.brand}
//                                                                         </span>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                             <div className='flex justify-between w-5/12 sm:w-full sm:mt-3'>
//                                                                 <div className='pl-4 sm:pl-0'>
//                                                                     <h2 className={` ${sellerBoolShowSitePayments ? 'text-lg' : 'hidden'} `} style={{color:sellerPrimaryColor1}}>
//                                                                         {currencyFormat.format(pt.productInfo.price - Math.floor((pt.productInfo.price * pt.productInfo.discount) / 100))}
//                                                                     </h2>
//                                                                     <p className='hidden line-through'>$300</p>
//                                                                     <p className='hidden'>-15%</p>
//                                                                 </div>
//                                                             </div>
//                                                         </div>                    
//                                                     )
//                                                 }
//                                             </div>
//                                         </div>
//                                     )
//                                 }
//                             </div>
//                         </div>
//                         <div className='w-[33%] md-lg:w-full'>
//                             <div className='pl-3 md-lg:pl-0 md-lg:mt-5'>
//                                 <div className='border p-4 flex flex-col gap-3' 
//                                     style={{backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1}}>
//                                     <div className='text-xl font-bold border-none border-slate-600 flex '>
//                                         <span className={` ${isDeposit === 'true' ? 'hidden' : ''} flex`}>
//                                            <MdOutlineRestaurantMenu className='mr-1 mt-1' /> {sellerProductPluralTerm} 
//                                         </span> 
//                                         <span className='ml-1' >Summary</span>
//                                         {/*isDeposit sellerBoolShowSitePayments */}
//                                     </div>
//                                     <div className='flex justify-between items-center'>
//                                         <span className={` ${isDeposit === 'true' ? 'hidden' : 'font-semibold'} `}>
//                                             {items} {sellerProductPluralTerm}
//                                         </span>
//                                         <span className={`${isDeposit === 'true' ? 'font-semibold' : 'hidden'} `}>
//                                             Deposit
//                                         </span>
//                                         <span className={` ${isDeposit === 'true' || sellerBoolShowSitePayments ? '' : 'hidden'} font-semibold`}>
//                                             {currencyFormat.format(price)}
//                                         </span>                                        
//                                     </div>
//                                     <div className='flex justify-between items-center'>
//                                         <span className='hidden'>Shipping Fee</span>
//                                         <span className='hidden'>${shipping_fee}</span>
//                                     </div>
//                                     <div className='flex justify-between items-center'>
//                                         <span className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} `}>Total</span>
//                                         <span className={` ${sellerBoolShowSitePayments ? 'text-lg' : 'hidden'} `}>
//                                             {currencyFormat.format(price)}
//                                         </span>
//                                     </div>
//                                 <div className={``}>
//                                     <div className={` ${sellerBoolShowSitePayments ? 'hidden' : ''} `}>
//                                         Once You Finalize Your Order, We Will Send You A Final Quote.
//                                     </div>
//                                     <div className={` ${res ? 'hidden' : ''} mt-2 font-semibold`} >
//                                         If The Button Is Disabled, Please Complete The Event Details Section 
//                                         And Click Save Event Details.
//                                     </div>
//                                 </div>
                                
//                                 <button onClick={place_order_local} disabled={res ? false : true} 
//                                     className={` ${res ? 'bg-green-700' : 'bg-gray-400'} 
//                                     flex items-center justify-center w-full font-bold cursor-pointer px-5 py-[6px] 
//                                     rounded-lg text-[15px] text-white uppercase`}>
//                                     <MdOutlineRestaurantMenu size={'24'} className='mr-1 mt-0' /> Finalize My Menu
//                                 </button>
//                                 <button onClick={place_order_local} 
//                                     className={` ${sellerEnvironment === 'Prod' ? 'hidden' : ''} px-5 py-[6px] rounded-lg text-sm text-white uppercase`}
//                                     style={{backgroundColor:sellerPrimaryColor1}}>test payment</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>  
//             </div>
//         </section>       
//         <Footer/>
//     </div>
//     );
// };

// export default EventDetails;







